/* =========================================================================
   Rambowtech theme JS
   - Garage store (localStorage, mirrored to customer metafields via app)
   - Fitment client: app proxy (/apps/fitment/*) with embedded-JSON fallback
   - Cascading YMM selector, badge/CTA hydration, PDP fitment box
   - Cart line-item properties + misfit warnings, part-number search intercept
   ========================================================================= */
(function () {
  'use strict';

  var cfg = window.Rambowtech || {};
  var settings = Object.assign({
    proxyBase: '/apps/fitment',
    vehicleDataUrl: null,          // fallback JSON asset for the selector
    freeShipThreshold: 0,
    routes: { cartAdd: '/cart/add.js', cartUpdate: '/cart/update.js', cartChange: '/cart/change.js', cartJson: '/cart.js', cartPage: '/cart', search: '/search' }
  }, cfg.settings || {});
  var Core = window.RambowtechCore;

  var STORAGE_KEY = 'rambowtech:garage:v1';

  /* ---------------- utilities ---------------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function normalizePartNumber(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  function money(cents) {
    var n = cents / 100;
    if (window.Shopify && Shopify.formatMoney && settings.moneyFormat) {
      try { return Shopify.formatMoney(cents, settings.moneyFormat); } catch (e) { /* fall through */ }
    }
    return '$' + n.toFixed(2);
  }

  /* ---------------- toast ---------------- */

  var toastTimer = null;
  function toast(msg) {
    var el = $('[data-rt-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-rt-toast', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.className = 'rt-toast';
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2400);
  }

  var cartNoticeTimer = null;
  function showCartConfirmation(title) {
    var notice = $('[data-rt-cart-confirmation]');
    if (!notice) {
      notice = document.createElement('aside');
      notice.className = 'rt-cart-confirmation';
      notice.setAttribute('data-rt-cart-confirmation', '');
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      document.body.appendChild(notice);
    }
    notice.innerHTML = '<button class="rt-cart-confirmation__close" type="button" data-rt-cart-confirmation-close aria-label="Close cart confirmation">×</button>'
      + '<div class="rt-cart-confirmation__check" aria-hidden="true">✓</div>'
      + '<div class="rt-cart-confirmation__body"><strong>Added to your cart</strong><span>' + esc(title || 'Item') + '</span></div>'
      + '<a class="rt-btn rt-btn--dark rt-btn--sm" href="' + esc(Core ? Core.cartPageUrl(settings) : (settings.routes.cartPage || '/cart')) + '">View cart</a>';
    notice.hidden = false;
    notice.classList.remove('is-visible');
    window.requestAnimationFrame(function () { notice.classList.add('is-visible'); });
    clearTimeout(cartNoticeTimer);
    cartNoticeTimer = setTimeout(function () { notice.classList.remove('is-visible'); }, 5200);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-rt-cart-confirmation-close]')) return;
    var notice = e.target.closest('[data-rt-cart-confirmation]');
    if (notice) notice.classList.remove('is-visible');
  });

  /* ---------------- analytics ---------------- */

  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    } catch (e) { /* no-op */ }
  }

  /* ---------------- garage store ---------------- */

  var Garage = {
    read: function () {
      try {
        var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        if (raw && Array.isArray(raw.vehicles)) return raw;
      } catch (e) { /* ignore */ }
      return { vehicles: [], activeId: null };
    },
    write: function (state) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* ignore */ }
      document.dispatchEvent(new CustomEvent('rambow:garage-changed', { detail: state }));
      Garage.sync(state);
    },
    active: function () {
      var s = Garage.read();
      return s.vehicles.find(function (v) { return v.id === s.activeId; }) || null;
    },
    name: function (v) {
      return v ? [v.year, v.make, v.model, v.trim].filter(Boolean).join(' ') : '';
    },
    key: function (v) { return [v.year, v.make, v.model, v.trim || ''].join('|'); },
    save: function (vehicle, makeActive) {
      var s = Garage.read();
      var existing = s.vehicles.find(function (g) { return Garage.key(g) === Garage.key(vehicle); });
      if (!existing) {
        existing = Object.assign({ id: 'v' + Date.now() + Math.floor(Math.random() * 1e4) }, vehicle);
        s.vehicles.push(existing);
      }
      if (makeActive !== false) s.activeId = existing.id;
      Garage.write(s);
      return existing;
    },
    setActive: function (id) {
      var s = Garage.read();
      if (s.vehicles.some(function (v) { return v.id === id; })) { s.activeId = id; Garage.write(s); }
    },
    remove: function (id) {
      var s = Garage.read();
      s.vehicles = s.vehicles.filter(function (v) { return v.id !== id; });
      if (s.activeId === id) s.activeId = s.vehicles.length ? s.vehicles[0].id : null;
      Garage.write(s);
    },
    /* mirror to customer metafield through the fitment app when logged in */
    sync: function (state) {
      if (!settings.customerId) return;
      try {
        var body = JSON.stringify({ customer_id: settings.customerId, garage: state });
        navigator.sendBeacon
          ? navigator.sendBeacon(settings.proxyBase + '/garage', new Blob([body], { type: 'application/json' }))
          : fetch(settings.proxyBase + '/garage', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body });
      } catch (e) { /* ignore */ }
    }
  };

  /* ---------------- fitment API client ---------------- */

  /* Requests to the fitment app. Each caller falls back to the theme's own
     files, so a slow or missing app costs at most a few seconds, once: after a
     failure the app is skipped for 10 minutes in this browser tab. */
  var APP_DOWN_KEY = 'rambowtech:fitment-app-down';
  function appDown() {
    try { return Date.now() - Number(sessionStorage.getItem(APP_DOWN_KEY) || 0) < 10 * 60 * 1000; } catch (e) { return false; }
  }
  function markAppDown(down) {
    try {
      if (down) sessionStorage.setItem(APP_DOWN_KEY, String(Date.now()));
      else sessionStorage.removeItem(APP_DOWN_KEY);
    } catch (e) { /* ignore */ }
  }

  function api(path, params) {
    if (appDown()) return Promise.reject(new Error('fitment app unavailable'));
    var qs = params
      ? '?' + Object.keys(params).filter(function (k) { return params[k] != null && params[k] !== ''; })
          .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&')
      : '';
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 4000) : null;
    return fetch(settings.proxyBase + path + qs, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        if (!r.ok) {
          var err = new Error('fitment api ' + r.status);
          err.status = r.status;
          throw err;
        }
        return r.json();
      })
      .then(function (res) {
        clearTimeout(timer);
        markAppDown(false);
        return res;
      }, function (err) {
        clearTimeout(timer);
        /* skip the app after: not installed (404), not ready (503), no answer
           in time, or not JSON. A 400 is this request's own problem. */
        var badRequest = err.status >= 400 && err.status < 500 && err.status !== 404;
        if (!badRequest) markAppDown(true);
        throw err;
      });
  }

  /* Local resolver — mirrors the app's rules (SHOPIFY_ARCHITECTURE §2.4) for
     products whose fitment records are embedded on the page as JSON
     (metafield auto.fitment_data rendered by the product-card / PDP snippets). */
  function localFitStatus(data, v) {
    if (!data) return null;
    if (data.noFitment) return { status: 'na' }; /* not a vehicle part (e.g. air freshener): no check at all */
    if (data.universal) return { status: 'universal', note: data.note || 'Confirm dimensions and specs before ordering.' };
    if (!v) return { status: 'none' };
    var records = (data.records || []).filter(function (r) {
      return String(r.make).toLowerCase() === String(v.make).toLowerCase()
        && String(r.model).toLowerCase() === String(v.model).toLowerCase()
        && v.year >= r.year_start && v.year <= r.year_end;
    });
    if (!records.length) return { status: 'nofit' };
    // exclusions override inclusions
    var excluded = records.some(function (r) {
      return r.exclude && (!r.trims || !r.trims.length || (v.trim && r.trims.indexOf(v.trim) !== -1));
    });
    if (excluded) return { status: 'nofit', note: 'Excluded for this configuration' };
    var inclusive = records.filter(function (r) { return !r.exclude; });
    var candidates = [];
    var reason = null;
    for (var i = 0; i < inclusive.length; i++) {
      var r = inclusive[i];
      var needsTrim = r.trims && r.trims.length;
      if (needsTrim && v.trim && r.trims.indexOf(v.trim) === -1) continue;
      if (needsTrim && !v.trim) {
        candidates.push(r);
        reason = reason || 'trim';
        continue;
      }
      /* The garage does not capture engine or supplier qualifiers. A trim
         match alone cannot verify a restricted raw-feed application. */
      if (r.requiresVerification) {
        candidates.push(r);
        reason = reason || 'details';
        continue;
      }
      return { status: 'fits', note: r.note || null };
    }
    if (candidates.length) {
      var options = candidates.map(function (c) { return fitOption(c, v); });
      return { status: 'check', reason: reason, options: options, note: checkSummary(options) };
    }
    return { status: 'nofit', note: 'Not available for the ' + (v.trim || 'selected') + ' trim' };
  }

  /* One vehicle application the shopper has to match: trim, short engine
     ("2.5L I4") and any remaining supplier qualifiers ("AWD"). */
  function fitOption(r, v) {
    var o = { trims: r.trims || [], engine: r.engine_short || r.engine || '', extras: r.extras || [], note: '' };
    if (v && v.trim && o.trims.indexOf(v.trim) !== -1) o.trims = []; /* the shopper's own trim: already in the title */
    if (!o.engine && !o.extras.length && r.note) o.note = r.note;
    return o;
  }

  function optionText(o, labeled) {
    var parts = [];
    if (o.trims.length) parts.push((labeled ? 'Trim: ' : '') + o.trims.join(' / '));
    if (o.engine) parts.push((labeled ? 'Engine: ' : '') + o.engine);
    if (o.extras.length) parts.push(o.extras.join(', '));
    if (!parts.length && o.note) parts.push(o.note);
    return parts.join(' · ');
  }

  /* Short text for product cards and the cart line: the first application, plus a count of the rest. */
  function checkSummary(options) {
    var first = optionText(options[0], true) || 'Confirm options before ordering';
    return options.length > 1 ? first + ' (+' + (options.length - 1) + ' more)' : first;
  }

  /* "2.5L 2487CC 152Cu. In. l4 GAS DOHC Naturally Aspirated" -> "2.5L I4".
     The full engine text stays in the fitment table. */
  function shortEngine(engine) {
    if (!engine) return '';
    var disp = engine.match(/(\d+(?:\.\d+)?)\s*L\b/i);
    var cyl = engine.match(/\b([IiLlVvHhWw])\s?-?(\d{1,2})\b/);
    var out = [];
    if (disp) out.push(disp[1] + 'L');
    if (cyl) out.push((/[IiLl]/.test(cyl[1]) ? 'I' : cyl[1].toUpperCase()) + cyl[2]);
    if (/turbo/i.test(engine)) out.push('Turbo');
    else if (/supercharg/i.test(engine)) out.push('Supercharged');
    if (/diesel/i.test(engine)) out.push('Diesel');
    else if (/hybrid/i.test(engine)) out.push('Hybrid');
    else if (/electric/i.test(engine)) out.push('Electric');
    return out.length ? out.join(' ') : engine;
  }

  /* Supplier qualifier text ("; AWD, Base, Sport Utility") -> ["AWD"]: split on
     ";" and ",", drop blanks, repeats and words every listed trim already says. */
  function qualifierTokens(text, trims) {
    var trimTexts = (trims || []).map(function (t) { return ' ' + String(t).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' '; });
    var seen = {};
    return String(text || '').split(/[;,]/).map(function (t) { return t.trim(); }).filter(function (t) {
      var key = t.toLowerCase();
      if (!t || seen[key]) return false;
      seen[key] = 1;
      var norm = ' ' + key.replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
      return !trimTexts.length || !trimTexts.every(function (tt) { return tt.indexOf(norm) !== -1; });
    });
  }

  /* Raw Rithum fitment (metafield auto.fitment_raw):
     "YEAR|MAKE|MODEL|TRIM|ENGINE::Key:Value ..." records joined by "^^".
     Parsed client-side into the same shape as auto.fitment_data so badges,
     the fit checker and the PDP table work without a pre-import converter. */
  var RAW_ATTR_KEYS = ['Position', 'Mfrlabel', 'Note', 'PartType', 'Quantity Required'];

  function parseRawFitment(raw) {
    if (!raw || typeof raw !== 'string' || raw.indexOf('|') === -1) return null;
    var attrRe = new RegExp('\\b(' + RAW_ATTR_KEYS.join('|') + '):', 'g');
    var rows = raw.split('^^').map(function (s) { return s.trim(); }).filter(Boolean).map(function (rec) {
      var separator = rec.indexOf('::');
      var f = (separator < 0 ? rec : rec.slice(0, separator)).split('|');
      var details = separator < 0 ? '' : rec.slice(separator + 2).trim();
      var attrs = {};
      var parts = details.split(attrRe);
      for (var i = 1; i < parts.length; i += 2) attrs[parts[i]] = (parts[i + 1] || '').trim();
      var engine = (f[4] || '').trim();
      /* Unlabeled text, Mfrlabel and Note are qualifiers the shopper has to
         match; PartType repeats the product and Quantity Required is shown
         only when it isn't 1. Unknown "Key:Value" text stays inside them. */
      var qualifierText = [parts[0], attrs.Mfrlabel, attrs.Note].filter(Boolean).join(';');
      var qty = (attrs['Quantity Required'] || '').trim();
      var qualified = Boolean(engine || details);
      return { year: +f[0], make: (f[1] || '').trim(), model: (f[2] || '').trim(), trim: (f[3] || '').trim(), engine: engine, details: details,
        position: (attrs.Position || '').trim(), qualifierText: qualifierText, qty: qty, requiresVerification: qualified };
    }).filter(function (r) { return r.year && r.make && r.model; });
    if (!rows.length) return null;

    /* Collapse only contiguous years with identical application qualifiers. */
    var byTrim = {};
    rows.forEach(function (r) {
      var k = JSON.stringify([r.make, r.model, r.trim, r.engine, r.details]);
      if (!byTrim[k]) byTrim[k] = { row: r, years: {} };
      byTrim[k].years[r.year] = 1;
    });
    var records = [];
    Object.keys(byTrim).forEach(function (k) {
      var g = byTrim[k], r = g.row;
      var years = Object.keys(g.years).map(Number).sort(function (a, b) { return a - b; });
      var start = years[0], prev = years[0];
      for (var i = 1; i <= years.length; i++) {
        if (i === years.length || years[i] !== prev + 1) {
          records.push({ year_start: start, year_end: prev, make: r.make, model: r.model, trims: r.trim ? [r.trim] : null, engine: r.engine, details: r.details,
            position: r.position, qualifierText: r.qualifierText, qty: r.qty, requiresVerification: r.requiresVerification, exclude: false });
          if (i < years.length) { start = years[i]; prev = years[i]; }
        } else prev = years[i];
      }
    });
    /* Blank-trim records stay separate from trim-restricted records. */
    var merged = {};
    records.forEach(function (r) {
      var k = JSON.stringify([r.make, r.model, r.year_start, r.year_end, r.engine, r.details, Boolean(r.trims)]);
      if (merged[k] && r.trims) merged[k].trims.push(r.trims[0]); else merged[k] = r;
    });
    records = Object.keys(merged).map(function (k) {
      var r = merged[k];
      if (r.trims) r.trims.sort();
      r.engine_short = shortEngine(r.engine);
      r.extras = qualifierTokens(r.qualifierText, r.trims);
      r.note = [r.engine ? 'Engine: ' + r.engine : '', r.position ? 'Position: ' + r.position : '', r.extras.join(', '),
        r.qty && r.qty !== '1' ? 'Quantity required: ' + r.qty : ''].filter(Boolean).join(' · ') || null;
      return r;
    })
      .sort(function (a, b) {
        return a.make.localeCompare(b.make) || a.model.localeCompare(b.model) || a.year_start - b.year_start;
      });
    return { universal: false, note: null, records: records };
  }

  function embeddedData(productId, root) {
    root = root || document;
    var el = root.querySelector('script[data-rt-fitment="' + productId + '"]');
    if (el) { try { return JSON.parse(el.textContent); } catch (e) { /* fall through to raw */ } }
    var rawEl = root.querySelector('script[data-rt-fitment-raw="' + productId + '"]');
    if (rawEl) { try { return parseRawFitment(JSON.parse(rawEl.textContent)); } catch (e) { return null; } }
    return null;
  }

  /* Progressive enhancement of the PDP description panel: supplier bullet
     lists become a checkmark feature grid, the "Will fit for OEM #" line is
     highlighted, and the compare-your-part-number paragraph becomes an info
     callout. Unrecognized structures keep the plain styled rendering. */
  function enhanceDescription() {
    var body = $('.rt-pdp-desc__body');
    if (!body) return;

    /* Supplier feeds often send the feature list as one <p> with <br>
       separators ("OEM Replacement<br>Brand New<br>…"). Convert the first
       paragraph to a real list when every line is short, so it gets the
       checkmark treatment; prose paragraphs are left untouched. */
    var firstP = body.querySelector('p');
    if (firstP && !firstP.querySelector('ul, ol, img, table')) {
      var segs = firstP.innerHTML.split(/<br\s*\/?>/i)
        .map(function (s) { return s.trim(); }).filter(Boolean);
      var allShort = segs.length >= 2 && segs.length <= 8 && segs.every(function (s) {
        var text = s.replace(/<[^>]*>/g, '').replace(/&[a-z]+;/gi, ' ').trim();
        return text.length > 0 && text.length <= 60;
      });
      if (allShort) {
        var listEl = document.createElement('ul');
        listEl.innerHTML = segs.map(function (s) { return '<li>' + s + '</li>'; }).join('');
        firstP.parentNode.replaceChild(listEl, firstP);
      }
    }
    var CHECK = '<svg class="rt-desc-ic" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    var TAG = '<svg class="rt-desc-ic" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2H2v10l9.3 9.3a1.9 1.9 0 0 0 2.7 0l7.3-7.3a1.9 1.9 0 0 0 0-2.7z"/><circle cx="7.5" cy="7.5" r="1"/></svg>';
    var INFO = '<svg class="rt-desc-ic" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>';

    $$('ul', body).forEach(function (ul) {
      ul.classList.add('rt-desc-features');
      $$('li', ul).forEach(function (li) {
        var t = (li.textContent || '').trim();
        if (!t) { li.remove(); return; }
        if (/OEM\s*#|Partslink\s*#/i.test(t)) {
          li.classList.add('rt-desc-features__part');
          li.insertAdjacentHTML('afterbegin', TAG);
        } else {
          li.insertAdjacentHTML('afterbegin', CHECK);
        }
      });
    });

    $$('p', body).forEach(function (p) {
      var t = (p.textContent || '').trim();
      if (!t) { p.remove(); return; }
      if (/compare the OEM|Partslink Number|ensure 100% fitment/i.test(t)) {
        p.classList.add('rt-desc-callout');
        p.insertAdjacentHTML('afterbegin', INFO);
      }
    });
  }

  /* Fill the PDP fitment table when only raw Rithum data is available. */
  function renderRawFitTables() {
    $$('[data-rt-fit-rows]').forEach(function (host) {
      var data = embeddedData(host.getAttribute('data-rt-fit-rows'));
      if (!data || !data.records || !data.records.length) {
        host.innerHTML = '<div class="rt-fit-table__row"><span class="note" style="grid-column: 1 / -1;">No vehicle fitment listed for this part yet.</span></div>';
        return;
      }
      var html = data.records.map(function (r) {
        var years = r.year_start === r.year_end ? String(r.year_start) : r.year_start + '–' + r.year_end;
        return '<div class="rt-fit-table__row"><span class="years">' + years + '</span><span>'
          + esc(r.make + ' ' + r.model) + '</span><span>'
          + (r.trims && r.trims.length ? esc(r.trims.join(', ')) : 'All trims') + '</span><span class="note">'
          + (r.note ? esc(r.note) : '—') + '</span></div>';
      }).join('');
      if (data.note) html += '<div class="rt-fit-table__row"><span class="note" style="grid-column: 1 / -1;">' + esc(data.note) + '</span></div>';
      host.innerHTML = html;
    });
  }

  /* Resolve statuses for a list of product ids → Promise<{id: {status, note}}> */
  function checkProducts(ids) {
    var v = Garage.active();
    var out = {};
    var remote = [];
    ids.forEach(function (id) {
      var local = localFitStatus(embeddedData(id), v);
      if (local) out[id] = local; else remote.push(id);
    });
    if (!remote.length) return Promise.resolve(out);
    var params = { product_ids: remote.join(',') };
    if (v) params.vehicle = [v.year, v.make, v.model, v.trim || ''].join('|');
    function noData() {
      remote.forEach(function (id) {
        if (!out[id]) out[id] = { status: v ? 'check' : 'none', unavailable: Boolean(v), note: v ? 'No vehicle data for this part yet — confirm fit before ordering' : null };
      });
      return out;
    }
    return api('/check', params)
      .then(function (res) {
        (res.results || []).forEach(function (r) { out[r.product_id] = { status: r.status, note: r.note || null, unavailable: Boolean(r.unavailable) }; });
        return noData();
      })
      .catch(noData);
  }

  /* ---------------- badge / CTA rendering ---------------- */

  var BADGE = {
    fits: { cls: 'rt-pill--fits', label: function (v) { return 'Catalog match: ' + (v ? v.year + ' ' + v.model : 'vehicle'); } },
    nofit: { cls: 'rt-pill--nofit', label: function (v) { return 'Does not fit your ' + (v ? v.model : 'vehicle'); } },
    check: { cls: 'rt-pill--check', label: function () { return 'Check options'; } },
    universal: { cls: 'rt-pill--universal', label: function () { return 'Universal fit'; } },
    none: { cls: 'rt-pill--none', label: function () { return 'Select vehicle to check fit'; } },
    na: { cls: 'rt-pill--none', label: function () { return ''; } },
    /* no fitment data for this part, so neither a match nor a misfit can be shown */
    unknown: { cls: 'rt-pill--unknown', label: function () { return 'Fit unknown'; } }
  };

  function applyCardState(card, result, v) {
    var status = result.status;
    var b = result.unavailable ? BADGE.unknown : (BADGE[status] || BADGE.none);
    var badge = $('[data-rt-badge]', card);
    if (badge) {
      badge.className = 'rt-pill rt-product-card__badge ' + b.cls;
      badge.textContent = b.label(v);
    }
    var note = $('[data-rt-note]', card);
    if (note) {
      var showNote = result.note && !result.unavailable && (status === 'check' || status === 'fits');
      note.hidden = !showNote;
      if (showNote) note.textContent = result.note;
    }
    var cta = $('[data-rt-cta]', card);
    if (cta) {
      var url = card.getAttribute('data-product-url') || '#';
      if ((status === 'fits' || status === 'universal' || status === 'na') && card.getAttribute('data-available') !== 'false') {
        cta.textContent = cta.getAttribute('data-label-add') || 'Add to Cart';
        cta.className = 'rt-btn rt-btn--dark';
        cta.setAttribute('data-rt-action', 'add');
      } else if (status === 'none') {
        cta.textContent = cta.getAttribute('data-label-check') || 'Check Fit';
        cta.className = 'rt-btn rt-btn--outline';
        cta.setAttribute('data-rt-action', 'view');
      } else {
        cta.textContent = cta.getAttribute('data-label-view') || 'View Details';
        cta.className = 'rt-btn rt-btn--outline';
        cta.setAttribute('data-rt-action', 'view');
      }
      cta.setAttribute('data-url', url);
    }
    card.setAttribute('data-rt-status', result.unavailable ? 'unknown' : status);
  }

  function hydrateCards(root) {
    var cards = $$('[data-rt-card]', root);
    if (!cards.length) return Promise.resolve({});
    var ids = cards.filter(function (c) { return !c.hasAttribute('data-rt-fixed-status'); })
      .map(function (c) { return c.getAttribute('data-product-id'); });
    var v = Garage.active();
    return checkProducts(ids).then(function (map) {
      cards.forEach(function (card) {
        if (card.hasAttribute('data-rt-fixed-status')) {
          card.__rtFit = { status: card.getAttribute('data-rt-status') || 'check' };
          return;
        }
        var r = map[card.getAttribute('data-product-id')] || { status: 'none' };
        applyCardState(card, r, v);
        card.__rtFit = r;
      });
      document.dispatchEvent(new CustomEvent('rambow:fitment-hydrated', { detail: { results: map } }));
      return map;
    });
  }

  /* card CTA clicks (event delegation) */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-rt-cta]');
    if (!cta) return;
    var card = cta.closest('[data-rt-card]');
    if (!card) return;
    e.preventDefault();
    if (cta.getAttribute('data-rt-action') === 'add') {
      addToCart({
        variantId: card.getAttribute('data-variant-id'),
        quantity: 1,
        status: (card.__rtFit || {}).status || card.getAttribute('data-rt-status') || 'none',
        note: (card.__rtFit || {}).note,
        title: card.getAttribute('data-product-title') || '',
        trigger: cta
      });
    } else {
      window.location.href = cta.getAttribute('data-url') || card.getAttribute('data-product-url');
    }
  });

  /* ---------------- cart ---------------- */

  function addToCart(opts) {
    var v = Garage.active();
    var trigger = opts.trigger || null;
    var triggerLabel = trigger ? trigger.textContent : '';
    if (trigger) {
      trigger.disabled = true;
      trigger.textContent = 'Adding…';
      trigger.setAttribute('aria-busy', 'true');
    }
    function restoreTrigger(success) {
      if (!trigger) return;
      trigger.removeAttribute('aria-busy');
      if (success) {
        trigger.textContent = 'Added ✓';
        window.setTimeout(function () { trigger.disabled = false; trigger.textContent = triggerLabel; }, 1800);
      } else {
        trigger.disabled = false;
        trigger.textContent = triggerLabel;
      }
    }
    var properties = {};
    if (opts.status !== 'na') {
      if (v) properties._vehicle = Garage.name(v);
      if (opts.status && opts.status !== 'none') properties._fitment_status = opts.status;
      if (opts.note) properties._fitment_note = opts.note;
    }
    var body = { id: Number(opts.variantId), quantity: opts.quantity || 1 };
    if (Object.keys(properties).length) body.properties = properties;
    return fetch(settings.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return r.json();
    }).then(function (item) {
      setCartAttributes();
      updateCartCount();
      track('add_to_cart', { variant_id: opts.variantId, fitment_status: opts.status, vehicle: v ? Garage.name(v) : null });
      if (opts.status === 'nofit') track('misfit_add_anyway', { variant_id: opts.variantId });
      showCartConfirmation((opts.title || 'Item').split(' for ')[0]);
      restoreTrigger(true);
      $$('[data-rt-cart-count]').forEach(function (el) {
        el.classList.remove('is-updated');
        window.requestAnimationFrame(function () { el.classList.add('is-updated'); });
      });
      return item;
    }).catch(function (err) {
      restoreTrigger(false);
      toast(err.message || 'Could not add to cart');
    });
  }

  function setCartAttributes() {
    var v = Garage.active();
    return fetch(settings.routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Active vehicle': v ? Garage.name(v) : '' } })
    }).catch(function () { /* ignore */ });
  }

  function updateCartCount() {
    fetch(settings.routes.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-rt-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () { /* ignore */ });
  }

  /* ---------------- YMM selector (custom element) ---------------- */

  var vehicleDataCache = null;
  function fallbackVehicleData() {
    if (vehicleDataCache) return vehicleDataCache;
    vehicleDataCache = settings.vehicleDataUrl
      ? fetch(settings.vehicleDataUrl).then(function (r) { return r.json(); }).catch(function () { return null; })
      : Promise.resolve(null);
    return vehicleDataCache;
  }

  /* ---------------- catalog vehicle index (app-less YMM source) ----------------
     The Year→Make→Model→Trims index is PRE-BUILT from every product's fitment
     data and shipped as the theme asset vehicle-index.json (regenerate with
     build-vehicle-index.js after large imports). One small CDN-cached request
     powers the selector — never crawl the catalog client-side: at 10k+
     products that was a 170 MB download per visitor. */
  var vehicleIndexPromise = null;

  function buildVehicleIndex() {
    if (vehicleIndexPromise) return vehicleIndexPromise;
    if (!settings.vehicleIndexUrl) return Promise.resolve(null);
    var base = String(settings.vehicleIndexUrl);
    vehicleIndexPromise = fetch(base)
      .then(function (r) { if (!r.ok) throw new Error('vehicle index ' + r.status); return r.json(); })
      .then(function (data) {
        if (!data) return null;
        if (data.byYear) return data; /* legacy single-file index */
        if (!data.chunks) return null;
        /* chunked index: Shopify silently drops large assets, so the data is
           split into <1MB chunks (vehicle-index-1.json …) plus this manifest.
           Each year lives wholly in one chunk — merging is a shallow copy. */
        var fetches = [];
        for (var i = 1; i <= data.chunks; i++) {
          (function (n) {
            fetches.push(fetch(base.replace(/vehicle-index\.json[^/]*$/, 'vehicle-index-' + n + '.json'))
              .then(function (r) { if (!r.ok) throw new Error('index chunk ' + n); return r.json(); }));
          })(i);
        }
        return Promise.all(fetches).then(function (parts) {
          var byYear = {};
          parts.forEach(function (p) {
            var src = (p && p.byYear) || {};
            Object.keys(src).forEach(function (y) { byYear[y] = src[y]; });
          });
          return { byYear: byYear };
        });
      })
      .catch(function () { vehicleIndexPromise = null; return null; });
    return vehicleIndexPromise;
  }

  function YmmSource() {
    /* Each method resolves to an array of strings. Source order:
       fitment app proxy → catalog index built from product metafields →
       bundled vehicle-data JSON (demo-only placeholder). */
    function viaApi(path, params, pick) {
      return api(path, params).then(function (res) { return res[pick] || res.values || res; });
    }
    function viaLocal(fn) {
      return fallbackVehicleData().then(function (data) { return data ? fn(data) : []; });
    }
    function viaIndexOrLocal(fromIndex, fromLocal) {
      return buildVehicleIndex().then(function (idx) {
        if (idx && idx.byYear && Object.keys(idx.byYear).length) return fromIndex(idx.byYear) || [];
        return viaLocal(fromLocal);
      });
    }
    return {
      years: function () {
        return viaApi('/years', null, 'years').catch(function () {
          return viaIndexOrLocal(function (byYear) {
            return Object.keys(byYear).map(Number).sort(function (a, b) { return b - a; });
          }, function (d) { return d.years; });
        });
      },
      makes: function (year) {
        return viaApi('/makes', { year: year }, 'makes').catch(function () {
          return viaIndexOrLocal(function (byYear) {
            return Object.keys(byYear[year] || {}).sort();
          }, function (d) { return Object.keys(d.makes); });
        });
      },
      models: function (year, make) {
        return viaApi('/models', { year: year, make: make }, 'models').catch(function () {
          return viaIndexOrLocal(function (byYear) {
            return Object.keys((byYear[year] || {})[make] || {}).sort();
          }, function (d) { return Object.keys((d.makes[make] || {})); });
        });
      },
      trims: function (year, make, model) {
        return viaApi('/trims', { year: year, make: make, model: model }, 'trims').catch(function () {
          return viaIndexOrLocal(function (byYear) {
            return Object.keys(((byYear[year] || {})[make] || {})[model] || {}).sort();
          }, function (d) { return ((d.makes[make] || {})[model]) || []; });
        });
      }
    };
  }

  var ymmSource = YmmSource();

  function initYmm(rootEl) {
    var ySel = $('[data-rt-ymm-year]', rootEl);
    var mkSel = $('[data-rt-ymm-make]', rootEl);
    var mdSel = $('[data-rt-ymm-model]', rootEl);
    var trSel = $('[data-rt-ymm-trim]', rootEl);
    var catSel = $('[data-rt-ymm-cat]', rootEl);
    var btn = $('[data-rt-ymm-submit]', rootEl);
    if (!ySel || !mkSel || !mdSel || !btn) return;

    function fill(sel, values, placeholder) {
      var current = sel.value;
      sel.innerHTML = '<option value="">' + esc(placeholder) + '</option>' + values.map(function (o) {
        return '<option value="' + esc(o) + '">' + esc(o) + '</option>';
      }).join('');
      if (values.indexOf(current) !== -1) sel.value = current;
    }
    /* Saved vehicles may spell a make or model differently ("INFINITI", "Infiniti"). */
    function choose(sel, value) {
      sel.value = value || '';
      if (sel.value || !value) return;
      var want = String(value).toLowerCase();
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value.toLowerCase() === want) { sel.value = sel.options[i].value; return; }
      }
    }
    function refreshButton() {
      var ready = ySel.value && mkSel.value && mdSel.value;
      btn.classList.toggle('rt-btn--disabled', !ready);
      btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }

    var pickerTouched = false;
    rootEl.addEventListener('change', function () { pickerTouched = true; });
    ymmSource.years().then(function (years) {
      fill(ySel, years, ySel.getAttribute('data-placeholder') || 'Year');
      var saved = Garage.active();
      if (!saved || pickerTouched) return;
      ySel.value = String(saved.year);
      if (!ySel.value) return;
      return ymmSource.makes(ySel.value).then(function (makes) {
        if (pickerTouched) return;
        fill(mkSel, makes, mkSel.getAttribute('data-placeholder') || 'Make'); mkSel.disabled = false; choose(mkSel, saved.make);
        if (!mkSel.value) return;
        return ymmSource.models(ySel.value, mkSel.value).then(function (models) {
          if (pickerTouched) return;
          fill(mdSel, models, mdSel.getAttribute('data-placeholder') || 'Model'); mdSel.disabled = false; choose(mdSel, saved.model);
          if (!mdSel.value) return;
          refreshCatOptions(); refreshButton();
          if (trSel) return ymmSource.trims(ySel.value, mkSel.value, mdSel.value).then(function (trims) {
            if (pickerTouched) return;
            fill(trSel, trims, trSel.getAttribute('data-placeholder') || 'Trim (optional)'); trSel.disabled = false; choose(trSel, saved.trim);
          });
        });
      });
    }).catch(function () { refreshButton(); });

    mkSel.disabled = true; mdSel.disabled = true; if (trSel) trSel.disabled = true;
    refreshButton();

    ySel.addEventListener('change', function () {
      mkSel.disabled = !ySel.value; mdSel.disabled = true; if (trSel) trSel.disabled = true;
      mkSel.innerHTML = mdSel.innerHTML = '';
      if (ySel.value) ymmSource.makes(ySel.value).then(function (v) { fill(mkSel, v, mkSel.getAttribute('data-placeholder') || 'Make'); });
      resetCatOptions();
      refreshButton();
    });
    mkSel.addEventListener('change', function () {
      mdSel.disabled = !mkSel.value; if (trSel) trSel.disabled = true;
      mdSel.innerHTML = '';
      if (mkSel.value) ymmSource.models(ySel.value, mkSel.value).then(function (v) { fill(mdSel, v, mdSel.getAttribute('data-placeholder') || 'Model'); });
      resetCatOptions();
      refreshButton();
    });
    /* Part-type dropdown: filled with the SPECIFIC types available for the
       chosen vehicle (with counts), read from the make's fitment shard.
       Also warms the shard cache for the results page. */
    function resetCatOptions() {
      if (!catSel) return;
      catSel.innerHTML = '<option value="">All part types</option>';
      catSel.disabled = true;
    }
    function refreshCatOptions() {
      resetCatOptions();
      if (!catSel || !(ySel.value && mkSel.value && mdSel.value)) return;
      var requestKey = ySel.value + '|' + mkSel.value + '|' + mdSel.value;
      catSel.__rtKey = requestKey;
      vehicleItems({ year: ySel.value, make: mkSel.value, model: mdSel.value }).then(function (items) {
        if (catSel.__rtKey !== requestKey) return; /* selection changed while loading */
        var counts = {};
        items.forEach(function (it) {
          if (it.type) counts[it.type] = (counts[it.type] || 0) + 1;
        });
        var types = Object.keys(counts).sort();
        if (!types.length) return;
        types.forEach(function (t) {
          var o = document.createElement('option');
          o.value = t;
          o.textContent = t + ' (' + counts[t] + ')';
          catSel.appendChild(o);
        });
        catSel.disabled = false;
        var selectedType = new URLSearchParams(window.location.search).get('type');
        if (selectedType && types.indexOf(selectedType) !== -1) catSel.value = selectedType;
      }).catch(function () { /* keep "all parts" */ });
    }

    mdSel.addEventListener('change', function () {
      if (trSel) {
        trSel.disabled = !mdSel.value;
        trSel.innerHTML = '';
        if (mdSel.value) ymmSource.trims(ySel.value, mkSel.value, mdSel.value).then(function (v) { fill(trSel, v, trSel.getAttribute('data-placeholder') || 'Trim (optional)'); });
      }
      refreshCatOptions();
      refreshButton();
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!(ySel.value && mkSel.value && mdSel.value)) { toast('Select year, make and model first'); return; }
      var vehicle = Garage.save({ year: parseInt(ySel.value, 10), make: mkSel.value, model: mdSel.value, trim: trSel ? trSel.value : '' });
      track('vehicle_selected', { vehicle: Garage.name(vehicle) });
      toast('Now shopping parts for: ' + Garage.name(vehicle));
      var mode = rootEl.getAttribute('data-mode') || 'navigate';
      if (mode === 'navigate') {
        var url = '/collections/all?view=vehicle&vehicle=' + encodeURIComponent(Garage.key(vehicle));
        if (catSel && catSel.value) url += '&type=' + encodeURIComponent(catSel.value);
        window.location.href = url;
      }
      /* mode === 'stay' (PDP inline / garage form): hydration below re-renders */
    });
  }

  /* ---------------- garage chip / sticky fitment bar ---------------- */

  function renderGarageChrome() {
    var v = Garage.active();
    $$('[data-rt-garage-chip]').forEach(function (chip) {
      chip.classList.toggle('has-vehicle', !!v);
      var label = $('[data-rt-garage-chip-label]', chip);
      if (label) label.textContent = v ? Garage.name(v) : (chip.getAttribute('data-empty-label') || 'Select Your Vehicle');
    });
    $$('[data-rt-sticky-vehicle]').forEach(function (el) { el.textContent = v ? Garage.name(v) : 'No vehicle selected'; });
    $$('[data-rt-sticky-action]').forEach(function (el) {
      el.textContent = v ? (el.getAttribute('data-active-label') || 'Change') : (el.getAttribute('data-empty-label') || 'Select vehicle');
    });
    $$('[data-rt-active-vehicle-name]').forEach(function (el) { el.textContent = v ? Garage.name(v) : ''; });
    $$('[data-rt-vehicle-route]').forEach(function (box) {
      box.hidden = !v || vehicleTakeover;
      var link = $('[data-rt-vehicle-route-link]', box);
      var label = $('[data-rt-vehicle-route-label]', box);
      var query = box.getAttribute('data-query') || '';
      var identifier = isPartIdentifierQuery(query);
      if (link) { link.hidden = identifier; if (v) link.href = vehicleResultsUrl(v, query); }
      if (v && label) label.textContent = Garage.name(v);
    });
  }

  /* ---------------- mobile navigation ---------------- */

  function initMobileNav() {
    var toggle = $('[data-rt-nav-toggle]');
    var nav = $('[data-rt-main-nav]');
    if (!toggle || !nav) return;
    function sizeMenu() {
      if (!nav.classList.contains('is-open')) return;
      var availableHeight = window.innerHeight - nav.getBoundingClientRect().top;
      nav.style.maxHeight = Math.max(0, availableHeight) + 'px';
    }
    function close() {
      var returnFocus = nav.contains(document.activeElement);
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('rt-nav-open');
      if (returnFocus) toggle.focus();
    }
    toggle.addEventListener('click', function () {
      var open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('rt-nav-open', open);
      if (open) sizeMenu();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 720) close();
      else sizeMenu();
    });
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (a && !a.hasAttribute('aria-haspopup')) close(); /* a category with a dropdown opens it instead */
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- category dropdowns ----------------
     A category with a dropdown opens it on click or tap instead of going
     straight to its page, so there's time to pick a subcategory ("All …" at
     the top goes to the category itself). On phones the list opens under it. */
  function initNavDropdowns() {
    var nav = $('[data-rt-main-nav]');
    if (!nav) return;
    var items = $$('.rt-nav__item', nav).filter(function (item) {
      return !item.classList.contains('rt-nav__more') && item.querySelector(':scope > a[aria-haspopup]');
    });
    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      item.querySelector(':scope > a').setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    items.forEach(function (item) {
      var link = item.querySelector(':scope > a');
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !item.classList.contains('is-open');
        items.forEach(function (other) { if (other !== item) setOpen(other, false); });
        setOpen(item, open);
      });
      item.addEventListener('focusout', function (e) { if (e.relatedTarget && !item.contains(e.relatedTarget)) setOpen(item, false); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && item.classList.contains('is-open')) { e.stopPropagation(); setOpen(item, false); link.focus(); }
      });
    });
    document.addEventListener('click', function (e) {
      items.forEach(function (item) { if (!item.contains(e.target)) setOpen(item, false); });
    });
  }

  /* ---------------- category bar: "More" menu ----------------
     Wider than phones, the bar stays on one row. When its links don't fit,
     the lowest-priority ones move into "More": first the right-hand
     shortcuts (also in the lookup band and footer), then categories from the
     end. The first two links and Contact always stay on the bar. */
  function initNavMore() {
    var nav = $('[data-rt-main-nav]');
    var more = nav && $('[data-rt-nav-more]', nav);
    var panel = more && $('[data-rt-nav-more-panel]', more);
    var btn = more && $('button', more);
    if (!panel || !btn) return;

    var entries = [];
    Array.prototype.forEach.call(nav.children, function (el) {
      if (el === more || el.classList.contains('rt-nav__secondary')) return;
      if (el.classList.contains('rt-nav__essentials')) entries = entries.concat(Array.prototype.slice.call(el.children));
      else entries.push(el);
    });
    var secondary = $('.rt-nav__secondary', nav);
    var shortcuts = secondary ? $$('a', secondary).filter(function (a) { return !a.classList.contains('rt-nav__contact'); }) : [];
    var movable = entries.slice(2).concat(shortcuts);           /* panel order = bar order */
    var categories = entries.slice(2).reverse();               /* collapse from the end */
    var copies = [];
    movable.forEach(function (el) {
      var link = el.tagName === 'A' ? el : $('a', el);
      if (!link) return;
      var a = document.createElement('a');
      a.className = 'rt-nav__dd-link';
      a.href = link.getAttribute('href');
      a.textContent = (link.textContent || '').trim();
      if (link.getAttribute('aria-current')) a.setAttribute('aria-current', 'page');
      a.hidden = true;
      panel.appendChild(a);
      el.__rtMoreCopy = a;
      copies.push(el);
    });

    function setOpen(open) {
      more.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function overflows() {
      var limit = nav.getBoundingClientRect().right - parseFloat(getComputedStyle(nav).paddingRight) + 1;
      var items = entries.concat(shortcuts, [more], secondary ? $$('a', secondary) : []);
      return items.some(function (el) { return el.offsetParent !== null && el.getBoundingClientRect().right > limit; });
    }
    function collapse(el) {
      if (!el.__rtMoreCopy || el.offsetParent === null) return; /* not on the bar at this width (CSS) */
      el.classList.add('is-collapsed');
      el.__rtMoreCopy.hidden = false;
    }
    function fit() {
      copies.forEach(function (el) { el.classList.remove('is-collapsed'); el.__rtMoreCopy.hidden = true; });
      more.hidden = true;
      setOpen(false);
      if (window.innerWidth <= 720 || !overflows()) return;
      more.hidden = false;
      shortcuts.forEach(collapse); /* the shortcuts move together, so "More" never splits them */
      for (var i = 0; i < categories.length && overflows(); i++) collapse(categories[i]);
    }

    btn.addEventListener('click', function () { setOpen(!more.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (!more.contains(e.target)) setOpen(false); });
    more.addEventListener('focusout', function (e) { if (!more.contains(e.relatedTarget)) setOpen(false); });
    more.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && more.classList.contains('is-open')) { setOpen(false); btn.focus(); }
    });
    var frame = 0;
    window.addEventListener('resize', function () { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
  }

  /* ---------------- PDP fitment box ---------------- */

  /* The status icon comes from CSS (data-status on the box), not the text. */
  var FITBOX_TITLES = {
    fits: function (n) { return 'Catalog match for your ' + n; },
    nofit: function (n) { return 'Not listed for your ' + n; },
    check: function (n) { return 'Confirm fit for your ' + n; },
    universal: function () { return 'Universal fit'; },
    none: function () { return 'Check if this fits your vehicle'; }
  };

  function fitboxNote(r) {
    if (r.status === 'none') return 'Select your vehicle, or compare the part numbers above.';
    if (r.status === 'check' && r.unavailable) return 'We don’t have vehicle data for this part yet. Compare the part numbers above with your vehicle.';
    if (r.status === 'check' && r.options) {
      if (!fitboxOptionsHtml(r.options)) return 'Check the fitment details below before ordering.';
      return r.reason === 'trim' ? 'Listed for specific versions. Check that yours matches:' : 'Check that your vehicle matches:';
    }
    if (r.status === 'nofit') return r.note || ''; /* the title already says it isn't listed */
    return r.note || '';
  }

  /* One application: labeled rows. Several: one line each, up to three. */
  function fitboxOptionsHtml(options) {
    if (!options || !options.length) return '';
    if (options.length === 1) {
      var o = options[0], rows = [];
      if (o.trims.length) rows.push(['Trim', o.trims.join(' / ')]);
      if (o.engine) rows.push(['Engine', o.engine]);
      if (o.extras.length) rows.push(['Notes', o.extras.join(', ')]);
      if (!rows.length && o.note) rows.push(['Notes', o.note]);
      return rows.length ? '<dl>' + rows.map(function (row) { return '<dt>' + row[0] + '</dt><dd>' + esc(row[1]) + '</dd>'; }).join('') + '</dl>' : '';
    }
    var more = options.length - 3;
    return '<ul>' + options.slice(0, 3).map(function (opt) { return '<li>' + esc(optionText(opt, false)) + '</li>'; }).join('')
      + (more > 0 ? '<li class="rt-fitbox__more">+' + more + ' more in the fitment table</li>' : '') + '</ul>';
  }

  function initPdp() {
    var box = $('[data-rt-fitbox]');
    if (!box) return;
    var productId = box.getAttribute('data-product-id');
    var v = Garage.active();

    checkProducts([productId]).then(function (map) {
      var r = map[productId] || { status: 'none' };
      var status = r.status;
      box.setAttribute('data-status', status);
      var title = $('[data-rt-fitbox-title]', box);
      if (title) title.textContent = status === 'check' && r.unavailable ? 'Confirm fit before ordering' : FITBOX_TITLES[status](Garage.name(v));
      var note = $('[data-rt-fitbox-note]', box);
      if (note) {
        var text = fitboxNote(r);
        note.hidden = !text;
        note.textContent = text;
      }
      var optionsEl = $('[data-rt-fitbox-options]', box);
      if (optionsEl) {
        var optionsHtml = status === 'check' ? fitboxOptionsHtml(r.options) : '';
        optionsEl.innerHTML = optionsHtml;
        optionsEl.hidden = !optionsHtml;
      }
      var picker = $('[data-rt-fitbox-picker]', box);
      if (picker) picker.hidden = status !== 'none';
      var links = $('[data-rt-fitbox-links]', box);
      if (links) links.hidden = status === 'none';
      var garageLink = $('[data-rt-fitbox-garage]', box);
      if (garageLink) garageLink.textContent = status === 'check' && r.reason === 'trim' && v && !v.trim ? 'Choose your trim' : 'Change vehicle';
      var tableLink = $('[data-rt-fitbox-table]', box);
      if (tableLink) tableLink.hidden = Boolean(r.unavailable) || status === 'nofit';
      var partsLink = $('[data-rt-fitbox-partslink]', box);
      if (partsLink) partsLink.hidden = status !== 'nofit';

      /* buy button behavior */
      var addBtn = $('[data-rt-pdp-add]');
      if (addBtn) {
        /* "check" keeps the plain label: the fitment box right above already asks to confirm. */
        addBtn.textContent = status === 'nofit'
          ? (addBtn.getAttribute('data-label-checkfit') || 'Add to Cart (check fit)')
          : (addBtn.getAttribute('data-label-add') || 'Add to Cart');
        addBtn.__rtStatus = status;
        addBtn.__rtNote = r.note || null;
      }
      /* No vehicle selected: buying stays open (shoppers who already know the
         part number shouldn't be forced through the selector); the fitment
         box above asks them to select a vehicle or compare part numbers. */
      track(status === 'fits' || status === 'universal' ? 'fitment_confirmed' : (status === 'nofit' ? 'fitment_failed' : 'product_viewed'),
        { product_id: productId, status: status, vehicle: v ? Garage.name(v) : null });
    });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-rt-pdp-add]');
    if (addBtn) {
      e.preventDefault();
      var status = addBtn.hasAttribute('data-rt-no-fitment') ? 'na' : (addBtn.__rtStatus || 'none');
      var misfit = $('[data-rt-misfit]');
      if (status === 'nofit' && misfit) {
        /* the main button never adds a misfit — only the explicit "Add anyway" does */
        misfit.hidden = false;
        misfit.focus && misfit.focus();
        return;
      }
      var qtyInput = $('[data-rt-pdp-qty]');
      addToCart({
        variantId: addBtn.getAttribute('data-variant-id'),
        quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1,
        status: status,
        note: addBtn.__rtNote,
        title: addBtn.getAttribute('data-product-title') || document.title,
        trigger: addBtn
      });
      if (misfit) misfit.hidden = true;
      return;
    }
    var addAnyway = e.target.closest('[data-rt-misfit-add]');
    if (addAnyway) {
      e.preventDefault();
      var btn = $('[data-rt-pdp-add]');
      var qty = $('[data-rt-pdp-qty]');
      addToCart({
        variantId: addAnyway.getAttribute('data-variant-id') || (btn && btn.getAttribute('data-variant-id')),
        quantity: qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1,
        status: 'nofit',
        note: (btn && btn.__rtNote) || null,
        title: (btn && btn.getAttribute('data-product-title')) || document.title,
        trigger: addAnyway
      });
      var misfitBox = $('[data-rt-misfit]');
      if (misfitBox) misfitBox.hidden = true;
    }
  });

  function closeLightbox(lightbox) {
    if (lightbox.open) lightbox.close();
    lightbox.hidden = true;
    document.body.style.overflow = lightbox.__rtPreviousOverflow || '';
    var trigger = lightbox.__rtTrigger;
    if (trigger && trigger.isConnected) trigger.focus();
  }

  document.addEventListener('click', function (e) {
    var lightbox = $('[data-rt-lightbox]');
    if (!lightbox) return;
    var trigger = e.target.closest('[data-rt-lightbox-open]');
    if (trigger) {
      var mainImg = $('[data-rt-gallery-main] img');
      if (!mainImg) return;
      var big = $('[data-rt-lightbox-img]', lightbox);
      big.src = mainImg.src.replace(/width=\d+/, 'width=2000');
      big.alt = mainImg.alt || '';
      lightbox.__rtTrigger = trigger;
      lightbox.__rtPreviousOverflow = document.body.style.overflow;
      if (!lightbox.__rtReady) {
        lightbox.__rtReady = true;
        lightbox.addEventListener('cancel', function (event) { event.preventDefault(); closeLightbox(lightbox); });
      }
      lightbox.hidden = false;
      lightbox.showModal();
      document.body.style.overflow = 'hidden';
      $('[data-rt-lightbox-close]', lightbox).focus();
      return;
    }
    if (e.target.closest('[data-rt-lightbox-close]') || e.target === lightbox) closeLightbox(lightbox);
  });

  /* qty steppers (PDP + generic) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rt-qty-btn]');
    if (!btn) return;
    var wrap = btn.closest('.rt-qty');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var delta = btn.getAttribute('data-rt-qty-btn') === 'inc' ? 1 : -1;
    var min = input.hasAttribute('data-min-zero') ? 0 : 1;
    var next = Core ? Core.nextQuantity(input.value, delta, min) : Math.max(min, (parseInt(input.value, 10) || min) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- cart page ---------------- */

  function initCartPage() {
    var cartRoot = $('[data-rt-cart]');
    if (!cartRoot) return;
    var v = Garage.active();
    var lines = $$('[data-rt-cart-line]', cartRoot);
    if (!lines.length) return;
    var ids = [];
    lines.forEach(function (l) {
      var id = l.getAttribute('data-product-id');
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    /* "Added for <vehicle>" only when the line was added for a different vehicle than the one selected now */
    $$('[data-rt-line-vehicle]', cartRoot).forEach(function (el) {
      el.hidden = Boolean(v) && el.getAttribute('data-rt-line-vehicle') === Garage.name(v);
    });
    checkProducts(ids).then(function (map) {
      var misfits = 0, unchecked = 0, confirmed = 0, needsCheck = 0;
      lines.forEach(function (line) {
        var r = map[line.getAttribute('data-product-id')] || { status: 'none' };
        var pill = $('[data-rt-line-fit]', line);
        if (r.status === 'na') { if (pill) { pill.hidden = true; pill.setAttribute('data-fit-status', 'na'); } return; }
        var labels = {
          fits: 'Catalog match for ' + Garage.name(v) + ' — review details',
          nofit: 'This item may not fit your ' + (v ? Garage.name(v) : 'selected vehicle'),
          check: 'Confirm options before checkout',
          universal: 'Universal fit — confirm specs',
          none: 'No vehicle selected — confirm fitment before checkout'
        };
        if (pill) {
          pill.className = 'rt-pill ' + (r.unavailable ? BADGE.unknown : (BADGE[r.status] || BADGE.none)).cls;
          pill.textContent = r.unavailable ? 'Fit unknown — confirm fit before checkout' : labels[r.status];
          pill.setAttribute('data-fit-status', r.status);
        }
        if (r.status === 'nofit') misfits++;
        if (r.status === 'none') unchecked++;
        if (r.status === 'fits' || r.status === 'universal') confirmed++;
        if (r.status === 'check') needsCheck++;
      });
      var warn = $('[data-rt-cart-warning]', cartRoot);
      if (warn) {
        var msg = null;
        if (misfits > 0 && v) msg = misfits + (misfits === 1 ? ' item in your cart may not fit' : ' items in your cart may not fit') + ' your ' + Garage.name(v) + '. Review before checkout.';
        else if (unchecked > 0 && !v) msg = 'No vehicle selected. Confirm fitment before checkout.';
        warn.hidden = !msg;
        if (msg) { warn.textContent = msg; track('cart_fitment_warning_shown', { misfits: misfits }); }
      }
      var summary = $('[data-rt-cart-fit-summary]', cartRoot);
      if (summary) {
        var parts = [];
        if (confirmed) parts.push(confirmed + ' listed for your vehicle');
        if (needsCheck) parts.push(needsCheck + ' needs review');
        if (misfits) parts.push(misfits + ' may not fit');
        if (unchecked) parts.push(unchecked + ' not checked');
        summary.textContent = parts.length ? 'Fitment summary: ' + parts.join(' · ') : 'Fitment check complete.';
        summary.hidden = !parts.length && lines.every(function (l) { return (map[l.getAttribute('data-product-id')] || {}).status === 'na'; });
      }
    });
    setCartAttributes();

    function refreshFitmentSummary() {
      var counts = { fits: 0, universal: 0, check: 0, nofit: 0, none: 0 };
      $$('[data-rt-cart-line]', cartRoot).forEach(function (line) {
        var pill = $('[data-rt-line-fit]', line);
        var status = pill && pill.getAttribute('data-fit-status');
        if (status && Object.prototype.hasOwnProperty.call(counts, status)) counts[status]++;
      });
      var summary = $('[data-rt-cart-fit-summary]', cartRoot);
      if (summary) {
        var parts = [];
        var confirmed = counts.fits + counts.universal;
        if (confirmed) parts.push(confirmed + ' listed for your vehicle');
        if (counts.check) parts.push(counts.check + ' needs review');
        if (counts.nofit) parts.push(counts.nofit + ' may not fit');
        if (counts.none) parts.push(counts.none + ' not checked');
        summary.textContent = parts.length ? 'Fitment summary: ' + parts.join(' · ') : 'Fitment check complete.';
        summary.hidden = !parts.length && $$('[data-rt-line-fit]', cartRoot).every(function (pill) { return pill.getAttribute('data-fit-status') === 'na'; });
      }
      var warning = $('[data-rt-cart-warning]', cartRoot);
      if (warning) {
        var msg = null;
        var current = Garage.active(); /* the vehicle picked now: this runs long after the page set up */
        if (counts.nofit && current) msg = counts.nofit + (counts.nofit === 1 ? ' item in your cart may not fit ' : ' items in your cart may not fit ') + Garage.name(current) + '. Review before checkout.';
        else if (counts.none && !current) msg = 'No vehicle selected. Confirm fitment before checkout.';
        warning.hidden = !msg;
        if (msg) warning.textContent = msg;
      }
    }

    /* Order discounts Shopify takes off in the cart, the total after them, and the promo bar's
       code when it's applied but Shopify only takes it off at checkout. */
    function renderCartDiscounts(discounts, totalPrice) {
      var list = $('[data-rt-cart-discounts]', cartRoot);
      if (list) list.innerHTML = discounts.map(function (d) {
        return '<div class="rt-summary__row rt-summary__row--discount"><span>Discount (' + esc(d.title) + ')</span><span>−' + money(d.amount) + '</span></div>';
      }).join('');
      var totalRow = $('[data-rt-cart-total-row]', cartRoot);
      if (totalRow) {
        totalRow.hidden = !discounts.length;
        $('[data-rt-cart-total]', totalRow).textContent = money(totalPrice);
      }
      showPromoCodeNote(discounts.map(function (d) { return d.title; }));
    }
    function showPromoCodeNote(titles) {
      var note = $('[data-rt-cart-code-note]', cartRoot);
      var bar = $('[data-rt-promo]');
      if (!note) return;
      var code = bar && !bar.hidden ? bar.getAttribute('data-code') : '';
      var applied = false;
      try { applied = Boolean(code) && sessionStorage.getItem(PROMO_APPLIED_KEY) === code; } catch (e) { /* ignore */ }
      var inCart = titles.some(function (t) { return t.toUpperCase() === String(code).toUpperCase(); });
      note.hidden = !applied || inCart;
      if (!note.hidden) $('[data-rt-cart-code]', note).textContent = code;
    }
    var shownDiscounts = $('[data-rt-cart-discounts]', cartRoot);
    showPromoCodeNote(((shownDiscounts && shownDiscounts.getAttribute('data-codes')) || '').split('|').filter(Boolean));

    function renderEmptyCart() {
      cartRoot.innerHTML = '<h1 class="rt-page-title" style="margin-bottom: 20px;">Your cart</h1>'
        + '<div class="rt-empty" style="padding: 48px;"><div style="font-size: 17px; font-weight: 700;">Your cart is empty</div>'
        + '<a class="rt-btn" style="margin-top: 6px; padding: 11px 22px; font-size: 13.5px;" href="/collections/all">Continue shopping</a></div>';
    }

    function applyCart(cart) {
      var threshold = parseInt(cartRoot.getAttribute('data-free-shipping-threshold') || '0', 10);
      var state = Core ? Core.cartState(cart, threshold) : null;
      if (!state) return;
      cartRoot.setAttribute('data-cart-total', state.totalPrice);
      $$('[data-rt-cart-count]').forEach(function (el) { el.textContent = state.itemCount; });
      $$('[data-rt-cart-line]', cartRoot).forEach(function (line) {
        var key = line.getAttribute('data-line-key');
        var lineState = state.lines[key];
        if (!lineState) { line.remove(); return; }
        var input = $('[data-rt-line-qty]', line);
        var price = $('[data-rt-line-price]', line);
        if (input) {
          input.value = lineState.quantity;
          input.setAttribute('data-current-qty', lineState.quantity);
        }
        if (price) price.textContent = money(lineState.finalLinePrice);
        line.removeAttribute('aria-busy');
        $$('button, input', line).forEach(function (control) { control.disabled = false; });
      });
      if (!state.itemCount) { renderEmptyCart(); return; }
      var label = $('[data-rt-cart-summary-label]', cartRoot);
      var subtotal = $('[data-rt-cart-subtotal]', cartRoot);
      var shipping = $('[data-rt-cart-shipping]', cartRoot);
      if (label) label.textContent = 'Subtotal (' + state.itemCount + ' ' + (state.itemCount === 1 ? 'item' : 'items') + ')';
      if (subtotal) subtotal.textContent = money(state.itemsSubtotal);
      renderCartDiscounts(state.discounts, state.totalPrice);
      if (shipping) shipping.textContent = cartRoot.getAttribute('data-shipping-label') || (state.freeShipping ? 'FREE' : 'Calculated at checkout');
      var shipMessage = $('[data-rt-ship-message]', cartRoot);
      var shipLabel = $('[data-rt-ship-progress-label]', cartRoot);
      var shipProgress = $('[data-rt-ship-progress]', cartRoot);
      if (shipMessage) shipMessage.textContent = state.freeShipping ? 'You’ve unlocked free shipping' : money(state.remaining) + ' away from free shipping';
      if (shipLabel) shipLabel.textContent = state.freeShipping ? '✓' : money(state.totalPrice) + ' / ' + money(state.threshold);
      if (shipProgress) shipProgress.style.width = state.progress + '%';
      refreshFitmentSummary();
    }

    /* Quantity and removal updates happen in place from cart/change.js. This setup runs again
       when the vehicle changes; the listeners are added once, or each change would be sent twice. */
    if (cartRoot.__rtCartBound) return;
    cartRoot.__rtCartBound = true;
    cartRoot.addEventListener('change', function (e) {
      var input = e.target.closest('[data-rt-line-qty]');
      if (!input) return;
      changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10) || 0, input.closest('[data-rt-cart-line]'));
    });
    cartRoot.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rt-line-remove]');
      if (!rm) return;
      e.preventDefault();
      changeLine(rm.getAttribute('data-line-key'), 0, rm.closest('[data-rt-cart-line]'));
    });
    cartRoot.addEventListener('submit', function (e) {
      if (!e.target.closest('form[action*="/cart"]')) return;
      track('checkout_started', { value: (parseInt(cartRoot.getAttribute('data-cart-total') || '0', 10) / 100) });
    });
    function changeLine(key, qty, line) {
      var previousFocus = document.activeElement;
      var restoreFocus = !!(line && line.contains(previousFocus));
      function recoverFocus() {
        if (!restoreFocus) return;
        var current = document.activeElement;
        if (current && current !== document.body && current !== previousFocus && current.isConnected) return;
        if (previousFocus && previousFocus.isConnected && !previousFocus.disabled) { previousFocus.focus(); return; }
        var target = $('[data-rt-line-qty]', cartRoot) || $('h1', cartRoot) || $('a', cartRoot);
        if (target) { if (target.tagName === 'H1') target.setAttribute('tabindex', '-1'); target.focus(); }
      }
      if (line) {
        line.setAttribute('aria-busy', 'true');
        $$('button, input', line).forEach(function (control) { control.disabled = true; });
      }
      return fetch(settings.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not update cart'); });
        return r.json();
      }).then(function (cart) {
        applyCart(cart);
        recoverFocus();
        toast(qty === 0 ? 'Item removed from cart' : 'Cart quantity updated');
        return cart;
      }).catch(function (err) {
        if (line) {
          line.removeAttribute('aria-busy');
          $$('button, input', line).forEach(function (control) { control.disabled = false; });
          var input = $('[data-rt-line-qty]', line);
          if (input) input.value = input.getAttribute('data-current-qty') || '1';
        }
        recoverFocus();
        toast(err.message || 'Could not update cart');
      });
    }
  }

  /* ---------------- search result quality + vehicle refinement ---------------- */

  function initSearchQuality() {
    var grid = $('[data-rt-search-grid]');
    if (!grid) return;
    var cards = $$('[data-rt-card]', grid);
    var q = (new URLSearchParams(window.location.search).get('q') || '').toLowerCase();
    var intents = [
      { terms: ['tpms', 'tire pressure'], matches: ['tpms', 'tire pressure'] },
      { terms: ['headlight', 'headlamp'], matches: ['headlight', 'headlamp', 'head lamp'] },
      { terms: ['tail light', 'taillight'], matches: ['tail light', 'taillight', 'rear lamp'] },
      { terms: ['mirror'], matches: ['mirror'] },
      { terms: ['radiator'], matches: ['radiator'] },
      { terms: ['alternator'], matches: ['alternator'] },
      { terms: ['starter'], matches: ['starter'] },
      { terms: ['fuel pump'], matches: ['fuel pump'] }
    ];
    var intent = intents.find(function (item) { return item.terms.some(function (term) { return q.indexOf(term) !== -1; }); });
    if (!intent || !cards.length) return;
    var strong = cards.filter(function (card) {
      var text = card.textContent.toLowerCase();
      return intent.matches.some(function (term) { return text.indexOf(term) !== -1; });
    });
    if (!strong.length) {
      var notice = $('[data-rt-search-quality]');
      if (notice) {
        notice.hidden = false;
        notice.innerHTML = '<strong>No exact matches for “' + esc(new URLSearchParams(window.location.search).get('q')) + '”.</strong> Try selecting your vehicle or searching the part number.';
      }
    }
  }

  /* ---------------- search: part-number intercept ---------------- */

  function initSearchIntercept() {
    $$('form[data-rt-search-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var input = $('input[name="q"]', form);
        var q = input ? input.value.trim() : '';
        if (!q) { e.preventDefault(); return; }
        var normalized = normalizePartNumber(q);
        if (normalized.length < 5) return; /* plain keyword search */
        e.preventDefault();
        track('part_number_search', { q: q });
        api('/partnumber', { q: q }).then(function (res) {
          var matches = res.matches || [];
          if (matches.length) {
            try {
              sessionStorage.setItem('rambowtech:partnum', JSON.stringify({ q: q, matches: matches }));
            } catch (err) { /* ignore */ }
            if (matches.length === 1 && matches[0].url) { window.location.href = matches[0].url + '?pn=' + encodeURIComponent(q); return; }
          }
          window.location.href = settings.routes.search + '?q=' + encodeURIComponent(q);
        }).catch(function () {
          window.location.href = settings.routes.search + '?q=' + encodeURIComponent(q);
        });
      });
    });

    /* on the search results page: show the part-number-match banner */
    var banner = $('[data-rt-partnum-banner]');
    if (banner) {
      var stored = null;
      try { stored = JSON.parse(sessionStorage.getItem('rambowtech:partnum') || 'null'); } catch (e) { /* ignore */ }
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q');
      if (stored && q && stored.q === q && stored.matches.length) {
        banner.hidden = false;
        banner.textContent = 'Part number match — normalized “' + q + '” matched OE / interchange records';
        var grid = $('[data-rt-partnum-results]');
        if (grid) {
          grid.hidden = false;
          Promise.all(stored.matches.slice(0, 12).map(function (m) {
            return fetch('/products/' + m.handle + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
          })).then(function (products) {
            grid.innerHTML = products.filter(Boolean).map(function (p) {
              return '<a class="rt-mini-card" href="/products/' + esc(p.handle) + '">'
                + '<div class="rt-ph rt-mini-card__thumb">' + (p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="">' : '') + '</div>'
                + '<div>' + (p.vendor ? '<div class="rt-mini-card__brand">' + esc(p.vendor) + '</div>' : '') + '<div class="rt-mini-card__title">' + esc(p.title) + '</div>'
                + '<div class="rt-mini-card__price">' + money(p.price) + '</div></div></a>';
            }).join('');
          });
        }
      }
    }
  }

  /* ---------------- garage page ---------------- */

  function renderGaragePage() {
    var listEl = $('[data-rt-garage-list]');
    if (!listEl) return;
    var s = Garage.read();
    if (!s.vehicles.length) {
      listEl.innerHTML = '<div class="rt-garage-empty">No vehicles saved yet. Add your first vehicle →</div>';
      return;
    }
    listEl.innerHTML = s.vehicles.map(function (g) {
      var active = g.id === s.activeId;
      return '<div class="rt-garage-row' + (active ? ' is-active' : '') + '">'
        + '<div class="rt-ph rt-garage-row__thumb"></div>'
        + '<div style="flex:1"><div class="rt-garage-row__name">' + esc(Garage.name(g)) + '</div>'
        + '<div class="rt-garage-row__status">' + (active ? '● Active vehicle' : 'Saved') + '</div></div>'
        + '<div class="rt-garage-row__actions">'
        + (active ? '' : '<button class="rt-btn rt-btn--dark rt-btn--sm" data-rt-garage-activate="' + esc(g.id) + '">Set Active</button>')
        + '<button class="rt-btn rt-btn--sm" data-rt-garage-shop="' + esc(g.id) + '">Shop Parts</button>'
        + '<button class="rt-btn rt-btn--outline rt-btn--sm" data-rt-garage-remove="' + esc(g.id) + '">Remove</button>'
        + '</div></div>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-rt-garage-activate]'))) {
      Garage.setActive(t.getAttribute('data-rt-garage-activate'));
      track('vehicle_changed', { vehicle: Garage.name(Garage.active()) });
      toast('Active vehicle: ' + Garage.name(Garage.active()));
    } else if ((t = e.target.closest('[data-rt-garage-shop]'))) {
      Garage.setActive(t.getAttribute('data-rt-garage-shop'));
      var v = Garage.active();
      window.location.href = '/collections/all?view=vehicle&vehicle=' + encodeURIComponent(Garage.key(v));
    } else if ((t = e.target.closest('[data-rt-garage-remove]'))) {
      Garage.remove(t.getAttribute('data-rt-garage-remove'));
    }
  });

  /* ---------------- predictive search (autocomplete) ----------------
     Baymard-style: ≤6 product suggestions with image + price, query
     suggestions, ~200ms debounce, full keyboard support (combobox). */

  function initPredictiveSearch() {
    $$('[data-rt-search-wrap]').forEach(function (wrap, index) {
      var input = $('input[name="q"]', wrap);
      var panel = $('[data-rt-suggest]', wrap);
      if (!input || !panel || wrap.__rtSearchReady) return;
      wrap.__rtSearchReady = true;
      var timer = null;
      var items = [];
      var active = -1;
      var requestSequence = 0;
      var renderedQuery = '';
      panel.id = panel.id || 'rt-search-suggestions-' + index;
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', panel.id);
      input.setAttribute('aria-expanded', 'false');

      function highlight(idx) {
        items.forEach(function (el, i) {
          el.classList.toggle('is-active', i === idx);
          el.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        active = idx;
        if (items[idx]) input.setAttribute('aria-activedescendant', items[idx].id);
        else input.removeAttribute('aria-activedescendant');
      }
      function close() {
        clearTimeout(timer);
        requestSequence++;
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        highlight(-1);
      }
      function render(res, q) {
        var products = ((res.resources || {}).results || {}).products || [];
        var queries = ((res.resources || {}).results || {}).queries || [];
        if (!products.length && !queries.length) { renderedQuery = ''; close(); return; }
        var html = '';
        if (queries.length) {
          html += queries.slice(0, 3).map(function (suggestion) {
            return '<a class="rt-suggest__query" role="option" tabindex="-1" href="' + esc(suggestion.url) + '">' + suggestion.styled_text + '</a>';
          }).join('');
        }
        html += products.slice(0, 6).map(function (product) {
          return '<a class="rt-suggest__product" role="option" tabindex="-1" href="' + esc(product.url) + '">'
            + '<span class="rt-ph rt-suggest__thumb">' + (product.image ? '<img src="' + esc(product.image) + '" alt="" loading="lazy">' : '') + '</span>'
            + '<span class="rt-suggest__body">' + (product.vendor ? '<span class="rt-suggest__brand">' + esc(product.vendor) + '</span>' : '') + '<span class="rt-suggest__title">' + esc(product.title) + '</span>'
            + '<span class="rt-suggest__price">' + esc(product.price ? money(Math.round(parseFloat(product.price) * 100)) : '') + '</span></span></a>';
        }).join('');
        html += '<a class="rt-suggest__all" role="option" tabindex="-1" href="' + settings.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">Search for “' + esc(q) + '” →</a>';
        panel.innerHTML = html;
        items = $$('[role="option"]', panel);
        items.forEach(function (item, optionIndex) { item.id = panel.id + '-option-' + optionIndex; });
        renderedQuery = q;
        highlight(-1);
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      function schedule() {
        close();
        var q = input.value.trim();
        if (q.length < 2) return;
        var sequence = ++requestSequence;
        timer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q)
              + '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor')
            .then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); })
            .then(function (res) {
              if (sequence !== requestSequence || input.value.trim() !== q || document.activeElement !== input) return;
              render(res, q);
            })
            .catch(function () { if (sequence === requestSequence) close(); });
        }, 200);
      }
      input.addEventListener('input', schedule);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (panel.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); highlight(Math.min(items.length - 1, active + 1)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(Math.max(0, active - 1)); }
        else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); items[active].click(); }
        else if (e.key === 'Tab') close();
      });
      wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) close(); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      input.addEventListener('focus', function () {
        if (renderedQuery === input.value.trim() && items.length) {
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        } else if (input.value.trim().length >= 2) schedule();
      });
    });
  }

  /* ---------------- recently viewed ---------------- */

  var RECENT_KEY = 'rambowtech:recent:v1';

  function recordRecentlyViewed() {
    var el = $('[data-rt-product-handle]');
    if (!el) return;
    var handle = el.getAttribute('data-rt-product-handle');
    try {
      var seen = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').filter(function (h) { return h !== handle; });
      seen.unshift(handle);
      localStorage.setItem(RECENT_KEY, JSON.stringify(seen.slice(0, 12)));
    } catch (e) { /* ignore */ }
  }

  function renderRecentlyViewed() {
    var grid = $('[data-rt-recent-grid]');
    if (!grid) return;
    var current = ($('[data-rt-product-handle]') || {}).getAttribute
      ? $('[data-rt-product-handle]').getAttribute('data-rt-product-handle') : null;
    var seen = [];
    try { seen = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { /* ignore */ }
    seen = seen.filter(function (h) { return h !== current; }).slice(0, 4);
    if (!seen.length) { var wrap = grid.closest('[data-rt-recent-wrap]'); if (wrap) wrap.hidden = true; return; }
    Promise.all(seen.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) { var wrap = grid.closest('[data-rt-recent-wrap]'); if (wrap) wrap.hidden = true; return; }
      grid.innerHTML = products.map(function (p) {
        return '<a class="rt-mini-card" href="' + esc(p.url) + '">'
          + '<span class="rt-ph rt-mini-card__thumb">' + (p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="" loading="lazy">' : '') + '</span>'
          + '<span>' + (p.vendor ? '<span class="rt-mini-card__brand">' + esc(p.vendor) + '</span>' : '') + '<span class="rt-mini-card__title">' + esc(p.title) + '</span>'
          + '<span class="rt-mini-card__price" style="display:block">' + money(p.price) + '</span></span></a>';
      }).join('');
    });
  }

  /* ---------------- back to top ---------------- */

  function initBackToTop() {
    var btn = document.createElement('button');
    btn.className = 'rt-top-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '↑';
    btn.hidden = true;
    document.body.appendChild(btn);
    btn.addEventListener('click', function () {
      var destination = document.querySelector('.rt-skip-link') || document.getElementById('MainContent');
      if (destination) destination.focus({ preventScroll: true });
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'instant' : 'smooth' });
    });
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        btn.hidden = window.scrollY < 900;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------------- promo bar (sections/promo-bar.liquid) ---------------- */

  var PROMO_APPLIED_KEY = 'rambowtech:promo-applied';
  function initPromoBar() {
    var bar = $('[data-rt-promo]');
    if (!bar) return;
    var code = bar.getAttribute('data-code');
    /* past its last day (a page Shopify served from cache): the code no longer works */
    var lastDay = bar.getAttribute('data-last-day');
    var d = new Date();
    var today = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    if (lastDay && today > lastDay) { bar.hidden = true; return; }
    var showApplied = function () {
      $('[data-rt-promo-offer]', bar).hidden = true;
      $('[data-rt-promo-applied]', bar).hidden = false;
    };
    try { if (sessionStorage.getItem(PROMO_APPLIED_KEY) === code) showApplied(); } catch (e) { /* ignore */ }
    $('[data-rt-promo-apply]', bar).addEventListener('click', function () {
      try { sessionStorage.setItem(PROMO_APPLIED_KEY, code); } catch (e) { /* ignore */ }
    });
    $('[data-rt-promo-copy]', bar).addEventListener('click', function () {
      var copied = function () { toast('Code ' + code + ' copied'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(copied, function () { toast('Your code: ' + code); });
      else toast('Your code: ' + code);
    });
  }

  /* ---------------- placeholder support forms ---------------- */

  function initPlaceholderForms() {
    $$('form[data-rt-placeholder-form]').forEach(function (form) {
      if (form.__rtPlaceholderBound) return;
      form.__rtPlaceholderBound = true;
      var notice = document.createElement('div');
      notice.className = 'rt-product-card__note';
      notice.style.flexBasis = '100%';
      notice.setAttribute('role', 'status');
      notice.innerHTML = 'This form cannot send requests or look up orders. For tracking, use the order-status link in your confirmation email. '
        + '<a class="rt-link" href="/pages/contact">Contact support for help.</a>';
      form.appendChild(notice);
      $$('input, select, textarea', form).forEach(function (field) { field.disabled = true; });
      $$('button[type="submit"], input[type="submit"]', form).forEach(function (button) {
        button.disabled = true;
        if (button.tagName === 'INPUT') button.value = 'Online lookup unavailable';
        else button.textContent = 'Online lookup unavailable';
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        track('placeholder_form_unavailable', { form_type: form.getAttribute('data-track-event') || 'support' });
        toast('Nothing was submitted. Use the support link shown with this form.');
      });
    });
  }

  /* ---------------- vehicle-results takeover (PLP) ----------------
     On /collections/all?view=vehicle&vehicle=…, the server renders page 1 of
     the WHOLE catalog — at 10k products the odds a fitting part is in those 24
     are ~0, so hiding misfits shows "no results" even when parts exist. This
     takeover instead reads the per-make reverse shard (fit-<make>.json, built
     by build-vehicle-index.js) and renders exactly the matching products. */

  function vehicleResultsUrl(v, query) {
    var url = '/collections/all?view=vehicle&vehicle=' + encodeURIComponent(Garage.key(v));
    if (query) url += '&q=' + encodeURIComponent(query);
    return url;
  }

  function isPartIdentifierQuery(query) { return (String(query || '').match(/[0-9]/g) || []).length >= 5; }

  function normalizeVehicleSearch(value) {
    return String(value || '').toLowerCase().replace(/head[ -]?lamp/g, 'headlight')
      .replace(/tail[ -]?lamp|taillight|rear lamp/g, 'tail light').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function vehicleSearchMatches(product, query) {
    var terms = normalizeVehicleSearch(query).split(/\s+/).filter(Boolean);
    if (!terms.length) return true;
    var text = normalizeVehicleSearch([product.title, product.type, product.vendor].concat((product.variants || []).map(function (variant) { return variant.sku || ''; })).join(' '));
    var compact = normalizePartNumber(text);
    return terms.every(function (term) { return text.indexOf(term) !== -1; }) || compact.indexOf(normalizePartNumber(query)) !== -1;
  }

  function saveVehState() {
    var u = new URL(window.location.href), f = vehPlp.filters;
    u.searchParams.set('view', 'vehicle');
    u.searchParams.set('vehicle', Garage.key(Garage.active()));
    var pairs = [['type', vehPlp.typeFilter], ['sort_by', vehPlp.order], ['q', vehPlp.query],
      ['exact', f.exact ? '1' : ''], ['stock', f.inStock ? '1' : ''], ['min', f.priceMin], ['max', f.priceMax]];
    VEH_FACETS.forEach(function (fc) { pairs.push([fc.key, pickedOf(f, fc).join('|')]); });
    pairs.forEach(function (pair) {
      if (pair[1] !== null && pair[1] !== '') u.searchParams.set(pair[0], pair[1]); else u.searchParams.delete(pair[0]);
    });
    window.history.replaceState(null, '', u.toString());
  }

  function slugify(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  var vehicleTakeover = (function () {
    try {
      var p = new URLSearchParams(window.location.search);
      if (!(p.has('vehicle') || p.get('view') === 'vehicle')) return false;
      if (!document.querySelector('[data-rt-plp-grid]')) return false;
      /* shared/bookmarked vehicle links: adopt the URL's vehicle into the
         garage so first-time visitors get vehicle results too */
      if (p.get('vehicle')) {
        var f = String(p.get('vehicle')).split('|');
        var yr = parseInt(f[0], 10);
        if (yr && f[1] && f[2] && Garage.key(Garage.active() || {}) !== [yr, f[1], f[2], f[3] || ''].join('|')) Garage.save({ year: yr, make: f[1], model: f[2], trim: f[3] || '' });
      }
      return !!Garage.active();
    } catch (e) { return false; }
  })();

  var vehPlp = { key: null, items: [], loaded: {}, ctx: { sided: {} }, fit: {}, typeFilter: null, order: 'manual', filters: null, query: '', failures: 0, loading: false };


  /* ---------------- vehicle grid filters ----------------
     Facets come from what each part's card carries: the supplier's details
     (specs: bulb type, lens color, CAPA, ...) first, then the title. A detail
     neither gives is "Not specified", so those parts stay one tick away
     instead of vanishing from a filtered list. */
  var NOT_SPECIFIED = 'Not specified';

  function freshVehFilters() {
    var f = { exact: false, inStock: false, priceMin: null, priceMax: null };
    VEH_FACETS.forEach(function (fc) { f[fc.key] = {}; });
    return f;
  }

  function yes(value) { return /^(yes|true|1)$/i.test(String(value == null ? '' : value).trim()); }
  function specOf(p, key) {
    var v = p.specs && p.specs[key];
    return v == null ? '' : String(Array.isArray(v) ? v.join(', ') : v).trim();
  }
  /* The part's own name: the title before "for …", without "w/ …" extras
     ("Halogen Headlight w/ LED DRL for …" is a halogen headlight). */
  function partNameOf(p) {
    return String(p.title || '').split(/\s+(?:for|fits)\s+/i)[0].split(/\s+(?:w\/|with)\s+/i)[0];
  }
  /* Says the feature, and not "w/o …", "without …" or "non-…". */
  function says(text, re) {
    var m = re.exec(text);
    if (!m) return false;
    return !/(?:w\/o|without|non|no)[\s-]*$/i.test(text.slice(Math.max(0, m.index - 9), m.index));
  }
  function isLightPart(p) { return /light|lamp|bulb|reflector/i.test(p.type || partNameOf(p)) && !/mirror/i.test(p.type || ''); }
  function isTailLight(p) { return /tail\s*(light|lamp)/i.test((p.type || '') + ' ' + partNameOf(p)); }
  function isMirrorPart(p) { return /mirror/i.test(p.type || partNameOf(p)); }

  /* Position facet: the title ("… Left Driver", "… Right Passenger",
     "… Pair/Set"), then the supplier's position (left = driver side), then a
     title naming one side only ("… Left", "… RH"). */
  function positionOfProduct(p) {
    var t = String(p.title || '');
    if (/\bpair\b|\bset\b/i.test(t)) return 'Pair / Set';
    if (/passenger/i.test(t)) return 'Passenger Side';
    if (/driver/i.test(t)) return 'Driver Side';
    var s = specOf(p, 'position');
    if (/\bright\b/i.test(s)) return 'Passenger Side';
    if (/\bleft\b/i.test(s)) return 'Driver Side';
    var left = /\b(?:left|lh)\b/i.test(t), right = /\b(?:right|rh)\b/i.test(t);
    if (left !== right) return left ? 'Driver Side' : 'Passenger Side';
    return null;
  }
  /* A part of a type that comes in sides in this list (another part of its
     type names one): one with no side is "Not specified". */
  function comesInSides(p, ctx) { return Boolean(p.type && ctx && ctx.sided && ctx.sided[p.type]); }
  /* What a list's facets depend on beyond each part: the types that come in sides. */
  function facetContext(products) {
    var sided = {};
    products.forEach(function (p) { if (p && p.type && !sided[p.type] && positionOfProduct(p)) sided[p.type] = true; });
    return { sided: sided };
  }
  function mountOf(p) {
    var s = (specOf(p, 'position') + ' ' + partNameOf(p)).toLowerCase();
    if (/\binner\b|trunk|\blid\b|liftgate|tailgate|back ?door|hatch/.test(s)) return 'Inner (trunk / liftgate)';
    if (/\bouter\b|quarter|\bbody\b/.test(s)) return 'Outer (on body)';
    return null;
  }
  function bulbOf(p) {
    var s = specOf(p, 'light'), name = partNameOf(p);
    var from = s || name;
    if (/\b(hid|xenon)\b/i.test(from)) return 'HID / Xenon';
    if (/\bled\b/i.test(from)) return 'LED';
    if (/\bhalogen\b/i.test(from)) return 'Halogen';
    if (/sealed/i.test(from)) return 'Sealed beam';
    return s || null;
  }
  var LENS_ORDER = ['red', 'amber', 'clear', 'smoked', 'black', 'chrome'];
  function lensOf(p) {
    var colors = specOf(p, 'lens').toLowerCase().split(/\s*(?:,|\/|&|\band\b)\s*/).filter(Boolean)
      .map(function (c) { return c === 'smoke' ? 'smoked' : c; });
    if (!colors.length) return null;
    colors = colors.filter(function (c, i) { return colors.indexOf(c) === i; });
    colors.sort(function (a, b) { return (LENS_ORDER.indexOf(a) + 1 || 99) - (LENS_ORDER.indexOf(b) + 1 || 99); });
    return colors.map(function (c) { return c.charAt(0).toUpperCase() + c.slice(1); }).join(' & ');
  }
  function assemblyOf(p) {
    var s = specOf(p, 'components').toLowerCase();
    if (/lens\s*(?:and|&|\/)\s*housing/.test(s)) return 'Lens & housing only';
    if (/complete\s+assembly|^assembly$/.test(s)) return 'Complete assembly';
    return null;
  }
  function adjustOf(p) {
    var t = String(p.title || '').replace(/\b(?:power|manual)\s+fold\w*/ig, '');
    if (says(t, /\bpower\b/i)) return 'Power';
    if (says(t, /\bmanual\b/i)) return 'Manual';
    return null;
  }
  function mirrorFeaturesOf(p) {
    var t = String(p.title || ''), out = [];
    if (says(t, /\bheated\b/i)) out.push('Heated');
    if (says(t, /\b(?:turn\s+)?signal\b/i)) out.push('Turn signal');
    if (says(t, /\bblind\s*spot\b/i)) out.push('Blind spot');
    if (says(t, /\bpuddle\b/i)) out.push('Puddle light');
    if (says(t, /\bpower\s+fold/i)) out.push('Power folding');
    if (says(t, /\bmemory\b/i)) out.push('Memory');
    if (says(t, /\bcamera\b/i)) out.push('Camera');
    return out;
  }
  function certsOf(p) {
    var out = [];
    if (yes(specOf(p, 'capa')) || says(String(p.title || ''), /\bcapa\b/i)) out.push('CAPA certified');
    if (yes(specOf(p, 'dot'))) out.push('DOT/SAE compliant');
    return out;
  }

  /* value(): one answer per part, any ticked option matches; values(): a
     list of features, every ticked one must be there. applies(p, ctx) keeps a
     facet to the parts it describes (bulb type for lights, features for
     mirrors); ctx is facetContext() of the list. The fitment app filters
     category pages with these same facets (scripts/extract-fit.mjs). */
  var VEH_FACETS = [
    { key: 'brands', head: 'Brand', value: function (p) { return p.vendor || null; } },
    { key: 'positions', head: 'Position', applies: comesInSides, unknown: true, order: ['Driver Side', 'Passenger Side', 'Pair / Set'], value: positionOfProduct },
    { key: 'mount', head: 'Tail light mount', applies: isTailLight, unknown: true, order: ['Outer (on body)', 'Inner (trunk / liftgate)'], value: mountOf },
    { key: 'bulb', head: 'Bulb type', applies: isLightPart, unknown: true, order: ['Halogen', 'LED', 'HID / Xenon', 'Sealed beam'], value: bulbOf },
    { key: 'lens', head: 'Lens color', applies: isLightPart, unknown: true, value: lensOf },
    { key: 'comp', head: 'Assembly', applies: isLightPart, unknown: true, order: ['Complete assembly', 'Lens & housing only'], value: assemblyOf },
    { key: 'incl', head: 'Included', applies: isLightPart, values: function (p) { return yes(specOf(p, 'bulbs')) ? ['Bulbs included'] : []; } },
    { key: 'adjust', head: 'Mirror adjustment', applies: isMirrorPart, unknown: true, order: ['Power', 'Manual'], value: adjustOf },
    { key: 'mirror', head: 'Mirror features', applies: isMirrorPart, values: mirrorFeaturesOf },
    { key: 'cert', head: 'Certification', values: certsOf }
  ];

  function pickedOf(f, fc) { return Object.keys(f[fc.key] || {}).filter(function (k) { return f[fc.key][k]; }); }
  function facetValueOf(fc, p, ctx) {
    var v = fc.value(p);
    if (v != null) return v;
    return fc.unknown && (!fc.applies || fc.applies(p, ctx)) ? NOT_SPECIFIED : null;
  }
  function facetPasses(fc, p, picked, ctx) {
    if (!picked.length) return true;
    if (fc.values) {
      var have = fc.values(p);
      return picked.every(function (x) { return have.indexOf(x) !== -1; });
    }
    return picked.indexOf(facetValueOf(fc, p, ctx)) !== -1;
  }
  var EXACT_STATUSES = ['fits', 'universal', 'na'];
  function exactFit(p) { var r = vehPlp.fit[p.id]; return Boolean(r && EXACT_STATUSES.indexOf(r.status) !== -1); }

  /* Parts for the chosen type and search, before the sidebar's filters. */
  function vehBaseList() {
    return vehPlp.items
      .filter(function (it) { return !vehPlp.typeFilter || it.type === vehPlp.typeFilter; })
      .map(function (it) { return vehPlp.loaded[it.handle]; })
      .filter(Boolean)
      .filter(function (p) { return vehicleSearchMatches(p, vehPlp.query); });
  }

  /* The sidebar filter a part fails: null for none, the filter's key for exactly one, '*' for
     more. The grid shows the parts that fail nothing; each option's count uses the parts that
     fail nothing but its own filter, so a count is what ticking that option would give. */
  function vehFailedFilter(p, f) {
    var failed = null;
    function fails(key) { failed = failed ? '*' : key; return failed === '*'; }
    for (var i = 0; i < VEH_FACETS.length; i++) {
      var picked = pickedOf(f, VEH_FACETS[i]);
      if (picked.length && !facetPasses(VEH_FACETS[i], p, picked, vehPlp.ctx) && fails(VEH_FACETS[i].key)) return failed;
    }
    if (f.exact && !exactFit(p) && fails('exact')) return failed;
    if (f.inStock && !p.available && fails('stock')) return failed;
    var dollars = p.price / 100;
    if (((f.priceMin != null && dollars < f.priceMin) || (f.priceMax != null && dollars > f.priceMax)) && fails('price')) return failed;
    return failed;
  }

  function vehFilteredList() {
    var f = vehPlp.filters || freshVehFilters();
    return vehBaseList().filter(function (p) { return vehFailedFilter(p, f) === null; });
  }

  /* Every loaded part for the vehicle, whatever its type (the type tiles count these). */
  function vehAllParts() {
    return vehPlp.items.map(function (it) { return vehPlp.loaded[it.handle]; }).filter(Boolean);
  }

  /* Fit answers for every part in the list, so "Exact fit only" can filter
     parts whose card hasn't been shown yet. */
  function ensureVehFit(products) {
    var missing = products.filter(function (p) { return !vehPlp.fit[p.id]; }).map(function (p) { return String(p.id); });
    var chunks = [];
    for (var i = 0; i < missing.length; i += 100) chunks.push(missing.slice(i, i + 100));
    return Promise.all(chunks.map(function (ids) {
      return checkProducts(ids).then(function (map) {
        ids.forEach(function (id) { if (!vehPlp.fit[id]) vehPlp.fit[id] = map[id] || { status: 'check' }; });
      });
    }));
  }

  function facetOptions(fc, products, picked, ctx) {
    var counts = {};
    products.forEach(function (p) {
      if (fc.applies && !fc.applies(p, ctx)) return;
      (fc.values ? fc.values(p) : [facetValueOf(fc, p, ctx)]).forEach(function (v) { if (v != null) counts[v] = (counts[v] || 0) + 1; });
    });
    picked.forEach(function (v) { if (!(v in counts)) counts[v] = 0; }); /* a ticked option stays visible */
    var order = fc.order || [];
    return Object.keys(counts).sort(function (a, b) {
      if (a === NOT_SPECIFIED || b === NOT_SPECIFIED) return a === NOT_SPECIFIED ? 1 : -1;
      var ia = order.indexOf(a), ib = order.indexOf(b);
      if (ia !== -1 || ib !== -1) return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
      return counts[b] - counts[a] || a.localeCompare(b);
    }).map(function (v) { return { value: v, count: counts[v] }; });
  }

  function checkHtml(kind, value, checked, label, count) {
    return '<label class="rt-check"><input type="checkbox" data-rt-vf="' + esc(kind) + '" value="' + esc(value) + '"' + (checked ? ' checked' : '') + '>'
      + '<span class="rt-check__box" aria-hidden="true"></span><span>' + esc(label)
      + (count != null ? ' <span class="rt-check__count">(' + count + ')</span>' : '') + '</span></label>';
  }

  /* Sidebar for the vehicle grid: exact fit, then the facets that have a
     choice to offer for these parts, price and availability. Part type lives
     in the tiles above. */
  function buildVehSidebar(focusRequest) {
    var aside = $('.rt-filters');
    if (!aside) return;
    var host = $('[data-rt-veh-filters]', aside);
    if (!host) {
      host = document.createElement('div');
      host.setAttribute('data-rt-veh-filters', '');
      aside.appendChild(host);
    }
    var products = vehBaseList();
    var f = vehPlp.filters;
    var failed = products.map(function (p) { return vehFailedFilter(p, f); });
    var v = Garage.active();
    var html = '<div class="rt-filters__title">Filter results</div>';
    html += '<div style="margin-bottom: 18px;">' + checkHtml('exact', '1', f.exact, 'Exact fit for my vehicle only')
      + (f.exact && v && !v.trim ? '<p class="rt-muted" style="font-size: 12px; margin: 4px 0 0 30px;">Add your trim to see trim-specific parts.</p>' : '') + '</div>';
    var active = f.exact || f.inStock || f.priceMin != null || f.priceMax != null;
    VEH_FACETS.forEach(function (fc) {
      var picked = pickedOf(f, fc);
      if (picked.length) active = true;
      var pool = products.filter(function (p, i) { return failed[i] === null || failed[i] === fc.key; });
      var options = facetOptions(fc, pool, picked, vehPlp.ctx);
      var show = fc.values ? options.length > 0 : options.length > 1 || picked.length > 0;
      if (!show) return;
      html += '<div style="margin-bottom: 18px;"><div class="rt-filters__head">' + esc(fc.head) + '</div><div class="rt-filters__group">'
        + options.map(function (o) { return checkHtml(fc.key, o.value, picked.indexOf(o.value) !== -1, o.value, o.count); }).join('') + '</div></div>';
    });
    html += '<div style="margin-bottom: 18px;"><div class="rt-filters__head">Price</div><div class="rt-price-range">'
      + '<input type="number" inputmode="numeric" placeholder="Min" min="0" data-rt-vf-pricemin' + (f.priceMin != null ? ' value="' + f.priceMin + '"' : '') + ' aria-label="Minimum price">'
      + '<span aria-hidden="true">–</span>'
      + '<input type="number" inputmode="numeric" placeholder="Max" min="0" data-rt-vf-pricemax' + (f.priceMax != null ? ' value="' + f.priceMax + '"' : '') + ' aria-label="Maximum price">'
      + '<button class="rt-btn rt-btn--dark" type="button" data-rt-vf-priceapply>Go</button></div></div>';
    html += '<div style="margin-bottom: 14px;">' + checkHtml('stock', '1', f.inStock, 'In stock only') + '</div>';
    if (active) html += '<div><a class="rt-link rt-filters__clear" href="#" data-rt-vf-clear>✕ Clear filters</a></div>';
    var activeEl = document.activeElement;
    var focusKind = focusRequest ? focusRequest.kind : (activeEl && host.contains(activeEl) ? activeEl.getAttribute('data-rt-vf') : null);
    var focusValue = focusRequest ? focusRequest.value : (focusKind ? activeEl.value : null);
    var focusPrice = activeEl && activeEl.hasAttribute('data-rt-vf-priceapply');
    var focusClear = activeEl && activeEl.hasAttribute('data-rt-vf-clear');
    host.innerHTML = html;
    if (focusKind) $$('[data-rt-vf]', host).some(function (el) { if (el.getAttribute('data-rt-vf') === focusKind && el.value === focusValue) { el.focus(); return true; } return false; });
    if (focusPrice) $('[data-rt-vf-priceapply]', host).focus();
    if (focusClear) { var firstControl = $('input,button', host); if (firstControl) firstControl.focus(); }

    $$('[data-rt-vf]', host).forEach(function (input) {
      input.addEventListener('change', function () {
        var kind = input.getAttribute('data-rt-vf');
        var after = function () { saveVehState(); renderVehGrid(); buildVehSidebar({ kind: kind, value: input.value }); };
        if (kind === 'stock') vehPlp.filters.inStock = input.checked;
        else if (kind === 'exact') {
          vehPlp.filters.exact = input.checked;
          if (input.checked) { ensureVehFit(vehAllParts()).then(after, after); return; }
        } else if (vehPlp.filters[kind]) vehPlp.filters[kind][input.value] = input.checked;
        after();
      });
    });
    var applyBtn = $('[data-rt-vf-priceapply]', host);
    if (applyBtn) applyBtn.addEventListener('click', function () {
      var mn = parseFloat($('[data-rt-vf-pricemin]', host).value);
      var mx = parseFloat($('[data-rt-vf-pricemax]', host).value);
      vehPlp.filters.priceMin = isNaN(mn) ? null : mn;
      vehPlp.filters.priceMax = isNaN(mx) ? null : mx;
      saveVehState(); renderVehGrid(); buildVehSidebar();
    });
    var clear = $('[data-rt-vf-clear]', host);
    if (clear) clear.addEventListener('click', function (e) {
      e.preventDefault();
      vehPlp.filters = freshVehFilters();
      saveVehState(); renderVehGrid(); buildVehSidebar();
    });
  }

  function shardUrl(make) {
    var base = String(settings.vehicleIndexUrl || '');
    if (!base) return null;
    return base.replace(/vehicle-index\.json[^/]*$/, 'fit-' + slugify(make) + '.json');
  }

  /* Parts listed for a vehicle's year, make and model: [{handle, type}].
     Asks the fitment app first (always current), then the make's file in the
     theme (fit-<make>.json, a snapshot); no file for a make = none stocked.
     Trim, engine and other details are checked per part afterwards. */
  var vehicleItemsCache = {};
  function vehicleItems(v) {
    var key = [v.year, v.make, v.model].join('|');
    if (!vehicleItemsCache[key]) {
      vehicleItemsCache[key] = api('/products', { vehicle: key })
        .then(function (res) {
          if (!res || !Array.isArray(res.products)) throw new Error('fitment app products');
          return res.products.map(function (p) { return { handle: p.handle, type: p.type || '' }; });
        })
        .catch(function () { return shardItems(v); });
      vehicleItemsCache[key].catch(function () { delete vehicleItemsCache[key]; });
    }
    return vehicleItemsCache[key];
  }
  function shardItems(v) {
    var url = shardUrl(v.make);
    if (!url) return Promise.reject(new Error('no vehicle files'));
    return fetch(url)
      .then(function (r) {
        if (r.status === 404) return null;
        if (!r.ok) throw new Error('shard ' + r.status);
        return r.json();
      })
      .then(function (shard) {
        var idxs = shard ? (shard.map || {})[v.year + '|' + v.model] || [] : [];
        return idxs.map(function (i) { return { handle: shard.products[i][0], type: shard.products[i][1] || '' }; });
      });
  }

  /* Small, vehicle-correct product set for homepage merchandising. Uses the
     same parts list as the vehicle results and favors a mix of part types
     before filling remaining slots. */
  function vehicleProducts(v, limit) {
    limit = Math.max(1, limit || 4);
    if (!v || !v.make) return Promise.resolve([]);
    return vehicleItems(v)
      .then(function (list) {
        var items = list.map(function (it) { return { handle: it.handle, type: it.type || 'Other parts' }; });
        var chosen = [], usedTypes = {};
        var want = limit + 2; /* spares in case a product's own data rules this vehicle out */
        items.forEach(function (it) {
          if (chosen.length < want && !usedTypes[it.type]) { chosen.push(it); usedTypes[it.type] = true; }
        });
        items.forEach(function (it) { if (chosen.length < want && chosen.indexOf(it) === -1) chosen.push(it); });
        return Promise.all(chosen.map(function (it) { return fetchVehProduct(it.handle); }))
          .then(function (products) {
            return products.filter(function (p) { return p && !rulesOutVehicle(p, v); }).slice(0, limit);
          });
      })
      .catch(function () { return []; });
  }

  /* One product for the vehicle results grid and the homepage's vehicle picks.
     The card comes from the theme (sections/vehicle-result-card), so it shows
     the same part numbers, CAPA mark and fit check as the collection grids.
     If that can't load, the product JSON still gives a basic card (vehCardHtml). */
  function fetchVehProduct(handle) {
    return fetch('/products/' + handle + '?section_id=vehicle-result-card')
      .then(function (r) {
        if (!r.ok) throw new Error('card ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var data = $('script[data-rt-veh-product]', tpl.content);
        var card = $('[data-rt-card]', tpl.content);
        if (!data || !card) throw new Error('card markup');
        var p = JSON.parse(data.textContent);
        p.card = card.outerHTML;
        p.fitData = embeddedData(p.id, tpl.content);
        return p;
      })
      .catch(function () {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      });
  }

  /* The vehicle index matches year, make and model only; a product's own
     fitment data can still rule the vehicle out (trim, exclusions). */
  function rulesOutVehicle(p, v) {
    var r = p.card ? localFitStatus(p.fitData, v) : null;
    return Boolean(r && r.status === 'nofit');
  }

  function skeletonCards(n) {
    var s = '';
    for (var i = 0; i < n; i++) {
      s += '<div class="rt-product-card" aria-hidden="true" style="padding-bottom: 14px;">'
        + '<div class="rt-ph" style="height: 150px;"></div>'
        + '<div class="rt-ph" style="height: 13px; margin: 12px 12px 8px;"></div>'
        + '<div class="rt-ph" style="height: 13px; width: 55%; margin: 0 12px;"></div></div>';
    }
    return s;
  }

  function vehCardHtml(p, v) {
    if (p.card) return p.card;
    var variant = (p.variants && p.variants[0]) || {};
    var imgSrc = p.images && p.images[0]
      ? p.images[0] + (p.images[0].indexOf('?') > -1 ? '&' : '?') + 'width=480'
      : null;
    var media = imgSrc
      ? '<img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy" width="480" height="360">'
      : '<span class="rt-ph__label">img: ' + esc((p.title || '').slice(0, 24)) + '</span>';
    var compare = p.compare_at_price > p.price
      ? ' <span class="rt-price--compare">' + money(p.compare_at_price) + '</span>' : '';
    var stock = p.available
      ? ' <span class="rt-stock-flag">In stock</span>'
      : ' <span class="rt-stock-flag rt-stock-flag--out">Out of stock</span>';
    var cta = '<button class="rt-btn rt-btn--outline" type="button" data-rt-cta data-rt-action="view" data-url="' + esc(p.url) + '" data-label-view="Check Fitment">Check Fitment</button>';
    return '<article class="rt-product-card" data-rt-card data-rt-fixed-status data-rt-status="check"'
      + ' data-product-id="' + p.id + '" data-variant-id="' + (variant.id || '') + '"'
      + ' data-product-url="' + esc(p.url) + '" data-product-title="' + esc(p.title) + '">'
      + '<div class="rt-product-card__media-wrap"><a class="rt-product-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">'
      + '<div class="rt-ph">' + media + '</div></a>'
      + '<span class="rt-pill rt-product-card__badge rt-pill--check" data-rt-badge>Check trim &amp; options</span></div>'
      + '<div class="rt-product-card__body">'
      + '<div class="rt-product-card__meta">' + (p.vendor ? '<span>' + esc(p.vendor) + '</span>' : '') + (variant.sku ? '<span class="rt-mono">SKU ' + esc(variant.sku) + '</span>' : '') + '</div>'
      + '<a class="rt-product-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
      + '<div class="rt-price-row"><span class="rt-price">' + money(p.price) + '</span>' + compare + stock + '</div>'
      + cta + '</div></article>';
  }

  function updateVehCount(n) {
    var countWrap = $('[data-rt-count-wrap]');
    var countEl = $('[data-rt-result-count]');
    var nounEl = $('[data-rt-result-noun]');
    if (countWrap) countWrap.textContent = n + (n === 1 ? ' possible match' : ' possible matches') + (vehPlp.failures ? ' loaded · some listings could not be loaded' : '');
    if (countEl) countEl.textContent = n;
    if (nounEl) nounEl.textContent = n === 1 ? 'part' : 'parts';
    var sub = $('[data-rt-veh-sub]');
    if (sub) sub.textContent = n
      ? n + (n === 1 ? ' part matches' : ' parts match') + ' your year, make, and model.'
      : 'No matching parts for the current selection.';
  }

  function renderVehTiles(items) {
    var tiles = $('[data-rt-veh-cats]');
    if (!tiles) return;
    if (vehPlp.query) items = items.filter(function (it) { return vehPlp.loaded[it.handle] && vehicleSearchMatches(vehPlp.loaded[it.handle], vehPlp.query); });
    /* with sidebar filters picked, each type counts the parts it would show */
    var f = vehPlp.filters || freshVehFilters();
    if (vehActiveFilters(f)) items = items.filter(function (it) { var p = vehPlp.loaded[it.handle]; return p && vehFailedFilter(p, f) === null; });
    var counts = {};
    items.forEach(function (it) { counts[it.type] = (counts[it.type] || 0) + 1; });
    if (vehPlp.typeFilter && !counts[vehPlp.typeFilter]) counts[vehPlp.typeFilter] = 0; /* the chosen type stays, to go back from */
    var types = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    if (!types.length) { tiles.innerHTML = ''; return; } /* one type — tiles add nothing */
    tiles.innerHTML = '<button type="button" class="rt-veh-cat" data-rt-veh-all>All part types <span>' + items.length + '</span></button>' + types.map(function (t) {
      return '<button type="button" class="rt-veh-cat' + (vehPlp.typeFilter === t ? ' is-active' : '') + '" data-rt-veh-type="' + esc(t) + '">'
        + esc(t) + ' <span>' + counts[t] + '</span></button>';
    }).join('');
    $$('[data-rt-veh-type]', tiles).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = btn.getAttribute('data-rt-veh-type');
        vehPlp.typeFilter = vehPlp.typeFilter === t ? null : t;
        saveVehState(); renderVehGrid(); buildVehSidebar();
        $$('[data-rt-veh-type]', tiles).forEach(function (el) { if (el.getAttribute('data-rt-veh-type') === t) el.focus(); });
      });
    });
    var allTypes = $('[data-rt-veh-all]', tiles);
    if (allTypes) allTypes.addEventListener('click', function () { vehPlp.typeFilter = null; saveVehState(); renderVehGrid(); buildVehSidebar();
      var back = $('[data-rt-veh-all]', tiles); if (back) back.focus(); /* gone when the filters leave no parts */
    });
  }

  function renderVehEmpty(grid, v) {
    grid.innerHTML = '<div class="rt-empty">'
      + '<div style="font-size: 17px; font-weight: 700;">No parts listed for your ' + esc(Garage.name(v)) + ' yet</div>'
      + '<div style="display: flex; gap: 8px; flex-wrap: wrap; justify-content: center; margin-top: 6px;">'
      + '<a class="rt-btn" style="padding: 10px 20px; font-size: 13px;" href="/pages/contact">Send Us Your Part Number</a>'
      + '<a class="rt-btn rt-btn--outline" style="padding: 10px 20px; font-size: 13px;" href="/collections/all?view=all">Browse All Parts</a>'
      + '</div></div>';
  }

  function vehActiveFilters(f) {
    return f.exact || f.inStock || f.priceMin != null || f.priceMax != null || VEH_FACETS.some(function (fc) { return pickedOf(f, fc).length > 0; });
  }

  function renderVehGrid() {
    var grid = $('[data-rt-plp-grid]');
    var v = Garage.active();
    if (!grid || !v) return;
    renderVehTiles(vehPlp.items); /* type counts follow the sidebar filters */
    var list = vehFilteredList();
    if (vehPlp.order === 'price-ascending') list.sort(function (a, b) { return a.price - b.price; });
    if (vehPlp.order === 'price-descending') list.sort(function (a, b) { return b.price - a.price; });
    updateVehCount(list.length);
    var resultNotice = $('[data-rt-vehicle-result-notice]');
    if (resultNotice) { resultNotice.hidden = !vehPlp.failures; resultNotice.textContent = vehPlp.failures ? 'Some parts didn’t load. Refresh the page to try again.' : ''; }
    if (!list.length) {
      /* distinguish "no parts for this car" from "filters exclude everything" */
      if (vehPlp.items.length) {
        grid.innerHTML = '<div class="rt-empty"><div style="font-size: 15px; font-weight: 700;" tabindex="-1" data-rt-vehicle-empty-title>No parts match these filters</div>'
          + '<button type="button" class="rt-btn rt-btn--outline" data-rt-reset-vehicle-filters>Clear filters</button>'
          + '<a class="rt-link" href="' + esc(vehicleResultsUrl(v, '')) + '">All parts for this vehicle</a></div>';
        $('[data-rt-reset-vehicle-filters]', grid).addEventListener('click', function () {
          vehPlp.filters = freshVehFilters(); saveVehState(); renderVehGrid(); buildVehSidebar();
          var target = $('.rt-product-card__title', grid) || $('[data-rt-vehicle-empty-title]', grid);
          if (target) target.focus();
        });
        return;
      }
      renderVehEmpty(grid, v);
      return;
    }
    var html = list.map(function (p) { return vehCardHtml(p, v); }).join('');
    grid.innerHTML = html;
    hydrateVehCards(grid, v);
  }

  /* Badge, note and button for the vehicle grid's cards. Results are kept, so
     re-rendering after a filter change doesn't check the same parts again. */
  function hydrateVehCards(grid, v) {
    var pending = [];
    $$('[data-rt-card]', grid).forEach(function (card) {
      if (card.hasAttribute('data-rt-fixed-status')) { card.__rtFit = { status: card.getAttribute('data-rt-status') || 'check' }; return; }
      var known = vehPlp.fit[card.getAttribute('data-product-id')];
      if (known) { applyCardState(card, known, v); card.__rtFit = known; } else pending.push(card);
    });
    if (!pending.length) return;
    checkProducts(pending.map(function (card) { return card.getAttribute('data-product-id'); })).then(function (map) {
      pending.forEach(function (card) {
        var id = card.getAttribute('data-product-id');
        var r = map[id] || { status: 'check' };
        vehPlp.fit[id] = r;
        applyCardState(card, r, v);
        card.__rtFit = r;
      });
    });
  }

  function loadVehProducts(items) {
    var queue = items.slice();
    function next() {
      var batch = queue.splice(0, 12);
      if (!batch.length) return Promise.resolve();
      return Promise.all(batch.map(function (it) {
        return fetchVehProduct(it.handle)
          .then(function (p) { if (p) vehPlp.loaded[it.handle] = p; else vehPlp.failures++; });
      })).then(next);
    }
    return next();
  }

  function initVehiclePlp() {
    if (!vehicleTakeover) return;
    var grid = $('[data-rt-plp-grid]');
    var v = Garage.active();
    if (!grid || !v) return;
    var key = Garage.key(v);
    if (vehPlp.key === key) return; /* already rendered for this vehicle */
    vehPlp.key = key;
    /* honor a ?type= preselection from the category dropdown */
    try { vehPlp.typeFilter = new URLSearchParams(window.location.search).get('type') || null; } catch (e) { vehPlp.typeFilter = null; }
    vehPlp.loaded = {};
    vehPlp.ctx = { sided: {} };
    vehPlp.fit = {};

    /* server-page machinery doesn't apply to client-rendered results;
       the sidebar itself stays — buildVehSidebar fills it with facets */
    ['[data-rt-pagination]', '[data-rt-onlyfit]', '[data-rt-filter-form]', '[data-rt-perpage]', '[data-rt-load-more-wrap]'].forEach(function (sel) {
      var el = $(sel); if (el) el.hidden = true;
    });
    vehPlp.filters = freshVehFilters();
    var savedParams = new URLSearchParams(window.location.search);
    vehPlp.query = savedParams.get('q') || '';
    vehPlp.order = savedParams.get('sort_by') || 'manual';
    VEH_FACETS.forEach(function (fc) { (savedParams.get(fc.key) || '').split('|').filter(Boolean).forEach(function (value) { vehPlp.filters[fc.key][value] = true; }); });
    vehPlp.filters.exact = savedParams.get('exact') === '1';
    vehPlp.filters.inStock = savedParams.get('stock') === '1';
    ['min', 'max'].forEach(function (kind) { var raw = savedParams.get(kind); var value = raw === null ? NaN : Number(raw); if (Number.isFinite(value) && value >= 0) vehPlp.filters[kind === 'min' ? 'priceMin' : 'priceMax'] = value; });
    vehPlp.failures = 0;
    var recovery = $('[data-rt-vehicle-recovery]');
    if (recovery) {
      recovery.hidden = false;
      var broad = $('[data-rt-broad-results]', recovery);
      if (broad) broad.href = vehPlp.query ? '/search?type=product&q=' + encodeURIComponent(vehPlp.query) : '/collections/all?view=all';
      var queryLabel = $('[data-rt-vehicle-query]', recovery);
      if (queryLabel) queryLabel.textContent = vehPlp.query && !isPartIdentifierQuery(vehPlp.query) ? 'Results for “' + vehPlp.query + '”. ' : '';
      var allVehicle = $('[data-rt-all-vehicle-results]', recovery);
      if (allVehicle) allVehicle.href = vehicleResultsUrl(v, '');
    }
    var emptyServer = $('.rt-empty'); if (emptyServer) emptyServer.hidden = true;

    if (isPartIdentifierQuery(vehPlp.query)) {
      var count = $('[data-rt-count-wrap]'); if (count) count.textContent = 'Part numbers are searched across the whole catalog';
      var sub = $('[data-rt-veh-sub]'); if (sub) sub.textContent = '';
      grid.innerHTML = '<div class="rt-empty"><a class="rt-btn" href="/search?type=product&amp;q=' + encodeURIComponent(vehPlp.query) + '">See results for “' + esc(vehPlp.query) + '”</a></div>';
      return;
    }
    grid.innerHTML = skeletonCards(8);
    var fail = function () {
      vehPlp.key = null;
      grid.innerHTML = '<div class="rt-empty"><div style="font-size: 15px; font-weight: 700;">We couldn’t load results for your vehicle</div>'
        + '<div style="font-size: 13px; color: var(--rt-ink-4);">Please refresh the page, or <a class="rt-link" href="/collections/all?view=all">browse all parts</a>.</div></div>';
    };
    vehicleItems(v)
      .then(function (list) {
        vehPlp.items = list.map(function (it) { return { handle: it.handle, type: it.type || 'Other parts' }; });
        updateVehCount(vehPlp.items.length);
        if (!vehPlp.items.length) { renderVehEmpty(grid, v); return; }
        return loadVehProducts(vehPlp.items).then(function () {
          /* leave out parts their own fitment data rules out; keep the other results */
          vehPlp.items = vehPlp.items.filter(function (it) {
            var p = vehPlp.loaded[it.handle];
            var r = p && p.card ? localFitStatus(p.fitData, v) : null;
            if (!r) return true;
            if (r.status === 'nofit') return false;
            vehPlp.fit[p.id] = r;
            return true;
          });
          vehPlp.ctx = facetContext(vehPlp.items.map(function (it) { return vehPlp.loaded[it.handle]; }));
          var show = function () { renderVehGrid(); buildVehSidebar(); };
          /* a shared link with "Exact fit only" on needs every part's fit answer first */
          if (vehPlp.filters.exact) return ensureVehFit(vehAllParts()).then(show, show);
          show();
        });
      })
      .catch(fail);

    /* client-side sort for the takeover grid (server sort doesn't apply) */
    var sortSel = $('[data-rt-sort]');
    if (sortSel) { sortSel.value = vehPlp.order; $$('option', sortSel).forEach(function (option) { option.hidden = ['manual', 'price-ascending', 'price-descending'].indexOf(option.value) === -1; }); }
    if (sortSel && !sortSel.__rtVehBound) {
      sortSel.__rtVehBound = true;
      sortSel.addEventListener('change', function () {
        vehPlp.order = sortSel.value;
        saveVehState(); renderVehGrid();
      });
    }
  }

  /* ---------------- boot ---------------- */

  function hydrateAll() {
    initVehiclePlp();
    renderGarageChrome();
    hydrateCards(document);
    initPdp();
    initCartPage();
    renderGaragePage();
  }

  /* Paginate long fitment tables: 10 vehicles per page with a simple
     Previous / Next pager (mobile-friendly — two large tap targets beat a
     row of tiny page numbers). Works for both Liquid-rendered rows and rows
     built by renderRawFitTables (call after it). */
  function paginateFitTables() {
    var head = $('.rt-fit-table__head');
    if (!head) return;
    var panel = head.parentElement;
    $$('.rt-fit-table__row', panel).forEach(function (row) {
      row.setAttribute('role', 'row');
      Array.prototype.forEach.call(row.children, function (cell) {
        cell.setAttribute('role', 'cell');
        if (row.children.length === 1) cell.setAttribute('aria-colspan', '4');
      });
    });
    /* data rows have 4 cells; skip full-width note/status rows */
    var rows = $$('.rt-fit-table__row', panel).filter(function (r) { return r.children.length >= 3; });
    var PAGE = 10;
    if (rows.length <= PAGE + 2) return; /* 12 or fewer: just show them all */
    var pages = Math.ceil(rows.length / PAGE);
    var current = 0;

    var pager = document.createElement('div');
    pager.className = 'rt-fit-pager';
    pager.innerHTML = '<button type="button" class="rt-fit-pager__btn" data-dir="-1" aria-label="Previous vehicles">← Prev</button>'
      + '<span class="rt-fit-pager__status" aria-live="polite"></span>'
      + '<button type="button" class="rt-fit-pager__btn" data-dir="1" aria-label="Next vehicles">Next →</button>';
    panel.insertAdjacentElement('afterend', pager);
    var status = $('.rt-fit-pager__status', pager);

    function render() {
      var from = current * PAGE, to = from + PAGE;
      rows.forEach(function (r, i) { r.classList.toggle('rt-fit-hidden', i < from || i >= to); });
      status.textContent = 'Page ' + (current + 1) + ' of ' + pages + ' · ' + rows.length + ' vehicles';
      $$('.rt-fit-pager__btn', pager).forEach(function (b) {
        var next = current + parseInt(b.getAttribute('data-dir'), 10);
        b.disabled = next < 0 || next >= pages;
      });
    }
    pager.addEventListener('click', function (e) {
      var b = e.target.closest('.rt-fit-pager__btn');
      if (!b || b.disabled) return;
      current += parseInt(b.getAttribute('data-dir'), 10);
      render();
      var focusTarget = b.disabled ? $('.rt-fit-pager__btn:not(:disabled)', pager) : b;
      if (focusTarget) focusTarget.focus();
      head.scrollIntoView({ block: 'nearest' }); /* keep the table header in view on page flips */
    });
    render();
  }

  /* ---------------- category pages: the vehicle page's filters, from the fitment app ----------------
     A collection page keeps Shopify's own grid until a filter is picked. The
     sidebar shows the vehicle page's filters (plus part type) with counts for
     the whole collection, from the app's /browse; picking one swaps in the
     app's matching parts, a page at a time. Without the app, for a collection
     it doesn't know yet, or with Shopify's own filters in the address, the page
     stays Shopify's (grid and Search & Discovery filters). */
  var CAT_KEYS = ['types'].concat(VEH_FACETS.map(function (fc) { return fc.key; }));
  var CAT_PER_PAGE = [24, 48, 96];
  var catPlp = (function () {
    var state = { handle: null, picked: {}, inStock: false, min: null, max: null, sort: 'manual', serverSort: 'manual', perPage: 24,
      page: 1, pages: 1, total: 0, active: false, request: 0, original: null, cards: {}, shown: [], version: null, shopCount: NaN };
    try {
      var root = document.querySelector('[data-rt-collection]');
      var p = new URLSearchParams(window.location.search);
      if (!root || vehicleTakeover) return state;
      if (Array.prototype.some.call(Array.from(p.keys()), function (k) { return k.indexOf('filter.') === 0; })) return state;
      state.handle = root.getAttribute('data-rt-collection');
      state.shopCount = parseInt(root.getAttribute('data-rt-collection-count'), 10);
      CAT_KEYS.forEach(function (key) {
        var raw = p.get(key);
        if (raw) state.picked[key] = raw.split('|').filter(Boolean);
      });
      state.inStock = p.get('stock') === '1';
      ['min', 'max'].forEach(function (kind) {
        var value = p.get(kind) === null ? NaN : Number(p.get(kind));
        if (Number.isFinite(value) && value >= 0) state[kind] = value;
      });
      state.sort = state.serverSort = p.get('sort_by') || 'manual';
      var stored = parseInt(sessionStorage.getItem('rt:perpage') || '24', 10);
      if (CAT_PER_PAGE.indexOf(stored) !== -1) state.perPage = stored;
    } catch (e) { /* no storage or URL support: Shopify's page */ }
    state.active = Boolean(state.handle) && catFilterCount(state) > 0;
    return state;
  })();

  function catFilterCount(state) {
    var n = 0;
    CAT_KEYS.forEach(function (key) { n += (state.picked[key] || []).length; });
    return n + (state.inStock ? 1 : 0) + (state.min != null || state.max != null ? 1 : 0);
  }

  function catSaveState() {
    var u = new URL(window.location.href);
    CAT_KEYS.forEach(function (key) {
      var list = catPlp.picked[key] || [];
      if (list.length) u.searchParams.set(key, list.join('|')); else u.searchParams.delete(key);
    });
    [['stock', catPlp.inStock ? '1' : ''], ['min', catPlp.min], ['max', catPlp.max]].forEach(function (pair) {
      if (pair[1] !== null && pair[1] !== '') u.searchParams.set(pair[0], pair[1]); else u.searchParams.delete(pair[0]);
    });
    if (catPlp.active) {
      u.searchParams.delete('page'); /* the app pages its own results */
      if (catPlp.sort && catPlp.sort !== 'manual') u.searchParams.set('sort_by', catPlp.sort); else u.searchParams.delete('sort_by');
    }
    window.history.replaceState(null, '', u.toString());
  }

  /* Shopify's part count for this collection against the app's: a collection changed since the
     app last read it (parts picked by hand, new conditions) keeps Shopify's own filters for now. */
  function catCountsAgree(appCount) {
    var shop = catPlp.shopCount;
    if (!(shop >= 0) || appCount == null) return true;
    return Math.abs(appCount - shop) <= Math.max(3, Math.ceil(shop * 0.005));
  }

  /* `version`: ask for this version of the app's answer (pages read after it changed). */
  function catQuery(page, version) {
    var params = { collection: catPlp.handle, sort_by: catPlp.sort, page: page, per_page: catPlp.perPage,
      stock: catPlp.inStock ? '1' : '', min: catPlp.min, max: catPlp.max, v: version || '' };
    CAT_KEYS.forEach(function (key) { if ((catPlp.picked[key] || []).length) params[key] = catPlp.picked[key].join('|'); });
    return api('/browse', params);
  }

  /* The same card the collection grid renders (vehicle-result-card section), fetched once per part. */
  function catCard(handle) {
    if (!catPlp.cards[handle]) {
      catPlp.cards[handle] = fetchVehProduct(handle).then(function (p) { return p ? vehCardHtml(p, Garage.active()) : ''; });
    }
    return catPlp.cards[handle];
  }

  /* Swap Shopify's grid, count and paging for the app's (once), or put them back. */
  function catEnterAppMode() {
    var grid = $('[data-rt-plp-grid]');
    if (!grid) return;
    if (!catPlp.original) {
      var count = $('[data-rt-server-count]'), opener = $('[data-rt-filter-open]');
      catPlp.original = { grid: grid.innerHTML, count: count ? count.innerHTML : null, opener: opener ? opener.textContent : null, hidden: [] };
    }
    ['[data-rt-load-more-wrap]', '[data-rt-pagination]', '.rt-active-filters'].forEach(function (sel) {
      var el = $(sel);
      if (el && !el.hidden) { el.hidden = true; catPlp.original.hidden.push(el); }
    });
    $$('.rt-plp .rt-empty').forEach(function (el) { if (!el.closest('[data-rt-plp-grid]') && !el.hidden) { el.hidden = true; catPlp.original.hidden.push(el); } });
    catPlp.active = true;
  }
  function catLeaveAppMode() {
    var o = catPlp.original, grid = $('[data-rt-plp-grid]');
    catPlp.active = false;
    if (o && catPlp.sort !== catPlp.serverSort) {
      /* sorted differently while filtered: Shopify's grid in that order */
      var u = new URL(window.location.href);
      if (catPlp.sort === 'manual') u.searchParams.delete('sort_by'); else u.searchParams.set('sort_by', catPlp.sort);
      window.location.href = u.toString();
      return;
    }
    var more = $('[data-rt-cat-more]'); if (more) more.hidden = true;
    if (!o || !grid) return;
    grid.innerHTML = o.grid;
    var count = $('[data-rt-server-count]'); if (count && o.count != null) count.innerHTML = o.count;
    var opener = $('[data-rt-filter-open]'); if (opener && o.opener != null) opener.textContent = o.opener;
    o.hidden.forEach(function (el) { el.hidden = false; });
    catPlp.original = null;
    hydrateCards(grid);
  }

  function catUpdateCount(shown) {
    var count = $('[data-rt-server-count]');
    var total = catPlp.total;
    if (count) {
      count.innerHTML = total
        ? 'Showing <span data-rt-result-range>1–' + shown + '</span> of <strong data-rt-result-count>' + total.toLocaleString('en-US') + '</strong> <span data-rt-result-noun>' + (total === 1 ? 'part' : 'parts') + '</span>'
        : '<strong data-rt-result-count>0</strong> <span data-rt-result-noun>parts</span>';
    }
    var opener = $('[data-rt-filter-open]');
    var n = catFilterCount(catPlp);
    if (opener) opener.textContent = 'Filter' + (n ? ' (' + n + ')' : '');
    var more = $('[data-rt-cat-more]');
    if (!more) {
      var grid = $('[data-rt-plp-grid]');
      if (!grid) return;
      more = document.createElement('div');
      more.className = 'rt-load-more';
      more.setAttribute('data-rt-cat-more', '');
      more.innerHTML = '<span role="status" aria-live="polite" aria-atomic="true" data-rt-cat-more-status></span>'
        + '<button class="rt-btn rt-btn--outline" type="button" data-rt-cat-more-btn>Load more</button>';
      grid.parentNode.insertBefore(more, grid.nextSibling);
      $('[data-rt-cat-more-btn]', more).addEventListener('click', catLoadMore);
    }
    more.hidden = !catPlp.active || shown >= total;
    $('[data-rt-cat-more-status]', more).textContent = shown + ' of ' + total.toLocaleString('en-US') + ' parts loaded';
  }

  function catRenderCards(handles, append, req) {
    var grid = $('[data-rt-plp-grid]');
    /* a part already on the page is never added twice */
    handles = handles.filter(function (h, i) { return handles.indexOf(h) === i && (!append || catPlp.shown.indexOf(h) === -1); });
    return Promise.all(handles.map(catCard)).then(function (cards) {
      if (req !== catPlp.request || !grid) return null;
      var html = cards.join('');
      catPlp.shown = (append ? catPlp.shown : []).concat(handles);
      if (append) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html;
      hydrateCards(grid);
      return $$('[data-rt-card]', grid).length;
    });
  }

  function catRenderEmpty() {
    var grid = $('[data-rt-plp-grid]');
    if (!grid) return;
    grid.innerHTML = '<div class="rt-empty"><div style="font-size: 15px; font-weight: 700;" tabindex="-1" data-rt-cat-empty-title>No parts match these filters</div>'
      + '<button type="button" class="rt-btn rt-btn--outline" data-rt-cat-reset>Clear filters</button></div>';
    $('[data-rt-cat-reset]', grid).addEventListener('click', function () { catClear(); });
  }

  function catRenderSidebar(res, focusRequest) {
    var aside = $('.rt-filters');
    if (!aside) return;
    var form = $('[data-rt-filter-form]', aside);
    if (form) form.hidden = true;
    var host = $('[data-rt-cat-filters]', aside);
    if (!host) {
      host = document.createElement('div');
      host.setAttribute('data-rt-cat-filters', '');
      aside.appendChild(host);
    }
    var html = '<div class="rt-filters__title">Filter results</div>';
    (res.facets || []).forEach(function (facet) {
      var picked = catPlp.picked[facet.key] || [];
      html += '<div style="margin-bottom: 18px;"><div class="rt-filters__head">' + esc(facet.head) + '</div><div class="rt-filters__group">'
        + facet.options.map(function (o) { return checkHtml(facet.key, o.value, picked.indexOf(o.value) !== -1, o.value, o.count); }).join('') + '</div></div>';
    });
    html += '<div style="margin-bottom: 18px;"><div class="rt-filters__head">Price</div><div class="rt-price-range">'
      + '<input type="number" inputmode="numeric" placeholder="Min" min="0" data-rt-vf-pricemin' + (catPlp.min != null ? ' value="' + catPlp.min + '"' : '') + ' aria-label="Minimum price">'
      + '<span aria-hidden="true">–</span>'
      + '<input type="number" inputmode="numeric" placeholder="Max" min="0" data-rt-vf-pricemax' + (catPlp.max != null ? ' value="' + catPlp.max + '"' : '') + ' aria-label="Maximum price">'
      + '<button class="rt-btn rt-btn--dark" type="button" data-rt-vf-priceapply>Go</button></div></div>';
    html += '<div style="margin-bottom: 14px;">' + checkHtml('stock', '1', catPlp.inStock, 'In stock only') + '</div>';
    if (catFilterCount(catPlp)) html += '<div><a class="rt-link rt-filters__clear" href="#" data-rt-vf-clear>✕ Clear filters</a></div>';
    var activeEl = document.activeElement;
    var focusKind = focusRequest ? focusRequest.kind : (activeEl && host.contains(activeEl) ? activeEl.getAttribute('data-rt-vf') : null);
    var focusValue = focusRequest ? focusRequest.value : (focusKind ? activeEl.value : null);
    var focusPrice = activeEl && host.contains(activeEl) && activeEl.hasAttribute('data-rt-vf-priceapply');
    host.innerHTML = html;
    if (focusKind) $$('[data-rt-vf]', host).some(function (el) { if (el.getAttribute('data-rt-vf') === focusKind && el.value === focusValue) { el.focus(); return true; } return false; });
    if (focusPrice) $('[data-rt-vf-priceapply]', host).focus();

    $$('[data-rt-vf]', host).forEach(function (input) {
      input.addEventListener('change', function () {
        var kind = input.getAttribute('data-rt-vf');
        if (kind === 'stock') catPlp.inStock = input.checked;
        else {
          var list = (catPlp.picked[kind] || []).filter(function (v) { return v !== input.value; });
          if (input.checked) list.push(input.value);
          catPlp.picked[kind] = list;
        }
        catRefresh({ kind: kind, value: input.value });
      });
    });
    $('[data-rt-vf-priceapply]', host).addEventListener('click', function () {
      var mn = parseFloat($('[data-rt-vf-pricemin]', host).value);
      var mx = parseFloat($('[data-rt-vf-pricemax]', host).value);
      catPlp.min = isNaN(mn) || mn < 0 ? null : mn;
      catPlp.max = isNaN(mx) || mx < 0 ? null : mx;
      catRefresh();
    });
    var clear = $('[data-rt-vf-clear]', host);
    if (clear) clear.addEventListener('click', function (e) { e.preventDefault(); catClear(); });
  }

  function catClear() {
    catPlp.picked = {};
    catPlp.inStock = false;
    catPlp.min = catPlp.max = null;
    catRefresh().then(function () {
      var first = $('[data-rt-cat-filters] input');
      if (first) first.focus();
    });
  }

  /* Shopify's grid and filters again, after the app failed or doesn't know this collection. */
  function catFail() {
    var hadFilters = catPlp.active;
    catLeaveAppMode();
    var host = $('[data-rt-cat-filters]'); if (host) host.remove();
    var form = $('[data-rt-filter-form]'); if (form) form.hidden = false;
    catPlp.handle = null;
    if (!hadFilters) return;
    catPlp.picked = {}; catPlp.inStock = false; catPlp.min = catPlp.max = null;
    catSaveState();
    toast('Filters didn’t load. Showing all parts.');
  }

  function catRefresh(focusRequest) {
    var req = ++catPlp.request;
    var filtered = catFilterCount(catPlp) > 0;
    if (filtered) {
      catEnterAppMode();
      var grid = $('[data-rt-plp-grid]');
      if (grid) grid.innerHTML = skeletonCards(8);
      var more = $('[data-rt-cat-more]'); if (more) more.hidden = true;
    }
    catSaveState();
    return catQuery(1).then(function (res) {
      if (req !== catPlp.request) return;
      if (!res || !res.known) throw new Error('collection not in the fitment app');
      if (!catCountsAgree(res.count)) throw new Error('the fitment app has this collection out of date');
      catPlp.version = res.version || null;
      catRenderSidebar(res, focusRequest);
      if (!filtered) { catLeaveAppMode(); catSaveState(); return; }
      catPlp.total = res.total; catPlp.page = res.page; catPlp.pages = res.pages;
      if (!res.total) { catRenderEmpty(); catUpdateCount(0); return; }
      return catRenderCards(res.products, false, req).then(function (shown) { if (shown != null) catUpdateCount(shown); });
    }).catch(function () {
      if (req === catPlp.request) catFail();
    });
  }

  function catLoadMore() {
    var btn = $('[data-rt-cat-more-btn]');
    if (!btn || catPlp.page >= catPlp.pages) return;
    var req = catPlp.request;
    btn.textContent = 'Loading…';
    btn.setAttribute('aria-busy', 'true');
    var keepFocus = document.activeElement === btn;
    var before = $$('[data-rt-plp-grid] [data-rt-card]').length;
    catQuery(catPlp.page + 1, catPlp.version).then(function (res) {
      if (req !== catPlp.request || !res || !res.known) return;
      if (catPlp.version && res.version && res.version !== catPlp.version) return catReloadThrough(res.page, res.version, req);
      catPlp.page = res.page; catPlp.pages = res.pages; catPlp.total = res.total;
      return catRenderCards(res.products, true, req);
    }).then(function (shown) {
      if (shown == null) return;
      catUpdateCount(shown);
      if (keepFocus) {
        var added = $$('[data-rt-plp-grid] [data-rt-card]')[before];
        var title = added && $('.rt-product-card__title', added);
        if (title) title.focus();
      }
    }).catch(function () {
      toast('More parts didn’t load. Try again.');
    }).then(function () {
      btn.textContent = 'Load more';
      btn.removeAttribute('aria-busy');
    });
  }

  /* Prices or stock changed while the shopper was paging, so the order moved: show pages 1 to
     `page` again from the new answer, rather than repeating or skipping parts across pages. */
  function catReloadThrough(page, version, req) {
    var pages = [];
    for (var n = 1; n <= page; n++) pages.push(catQuery(n, version));
    return Promise.all(pages).then(function (all) {
      if (req !== catPlp.request || all.some(function (res) { return !res || !res.known; })) return null;
      var last = all[all.length - 1];
      catPlp.version = version; catPlp.page = last.page; catPlp.pages = last.pages; catPlp.total = last.total;
      return catRenderCards([].concat.apply([], all.map(function (res) { return res.products; })), false, req);
    });
  }

  function initCatalogFilters() {
    if (!catPlp.handle) return;
    if (catPlp.active) {
      catEnterAppMode();
      var grid = $('[data-rt-plp-grid]');
      if (grid) grid.innerHTML = skeletonCards(8);
    }
    var sortSel = $('[data-rt-sort]');
    if (sortSel) sortSel.addEventListener('change', function () {
      if (!catPlp.active) return; /* Shopify's grid: main-collection reloads the page sorted */
      catPlp.sort = sortSel.value;
      catRefresh();
    });
    var perSel = $('[data-rt-perpage]');
    if (perSel) perSel.addEventListener('change', function () {
      if (!catPlp.active) return;
      var n = parseInt(perSel.value, 10);
      if (CAT_PER_PAGE.indexOf(n) !== -1) catPlp.perPage = n;
      catRefresh();
    });
    catRefresh();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPromoBar();
    initMobileNav();
    initNavDropdowns();
    initNavMore();
    initCatalogFilters();
    renderRawFitTables();
    paginateFitTables();
    enhanceDescription();
    $$('[data-rt-ymm]').forEach(initYmm);
    initSearchIntercept();
    initSearchQuality();
    initPredictiveSearch();
    initPlaceholderForms();
    initBackToTop();
    recordRecentlyViewed();
    renderRecentlyViewed();
    hydrateAll();
  });

  document.addEventListener('rambow:garage-changed', hydrateAll);

  /* public API */
  window.Rambowtech = Object.assign(cfg, {
    settings: settings,
    garage: Garage,
    api: api,
    vehicleIndex: buildVehicleIndex,
    vehicleProducts: vehicleProducts,
    vehicleCardHtml: vehCardHtml,
    __vehicleTakeover: vehicleTakeover,
    /* a category page showing the fitment app's filtered parts (main-collection's paging stands down) */
    catalogFiltered: function () { return catPlp.active; },
    checkProducts: checkProducts,
    hydrateCards: hydrateCards,
    addToCart: addToCart,
    toast: toast,
    track: track,
    normalizePartNumber: normalizePartNumber,
    vehicleResultsUrl: vehicleResultsUrl
  });
})();



